import { Component, Inject, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { AppComponent } from '../app.component';
import { AppConstantes } from '../constants/app-constantes';
import { TipoOrigemAcordoEnum } from '../constants/origem-acordo.enum';
import { TipoProcedenciaAcordoEnum } from '../constants/procedencia-acordo.enum';
import { SituacaoParcelaEnum } from '../constants/situacao-parcela.enum';
import { TipoAcordoEnum } from '../constants/tipo-acordo.enum';
import { TipoParcelaAcordoEnum } from '../constants/tipo-parcela-acordo.enum';
import { Acordo, AcordoPaginado, CategoriaDevedor, Devedor, FormaPagamento, HonorarioFlutuante, Parcela, ProcedenciaAcordo, TipoOrigemAcordo, TipoRecebimento, TipoLinhaTelefonicaEnum, TipoPessoaEnum, AcordoResponse, Congenere, Telefone, EmailType, TipoFinalidadeTelefone, Paginacao, ParcelaLista, Escritorio, ScoreSerasa, Banco } from '../shared/services/acordo-ressarcimento/api/models';
import { DadosCalculoDivida } from '../shared/services/acordo-ressarcimento/api/models/dados-calculo-divida';
import { TipoCalculoDividaEnum } from '../shared/services/acordo-ressarcimento/api/models/tipo-calculo-divida-enum';
import { AcordoService, DominiosService, ODMService, ParcelaService, PropostaService, GuiaPostalService, CongenereService, EscritoriosService, UsuarioService, DevedoresService, ContaCreditoService } from '../shared/services/acordo-ressarcimento/api/services';
import { PsCPFValidator, PsModalLoadingComponent } from 'porto-seguro-guide';
import { CnpjAlfanumericoValidator } from '../shared/validators/cnpj-alfanumerico.validator';
import { CnpjUtils } from '../shared/utils/cnpj.utils';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Dinamica } from '../shared/services/acordo-ressarcimento/api/models/dinamica';
import { parse } from 'url';

@Component({
  selector: 'app-acordo',
  templateUrl: './acordo.component.html',
  styleUrls: ['./acordo.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AcordoComponent implements OnInit {

  @ViewChild('ModalConcluidoAcordo') modalConcluidoAcordo: PsModalLoadingComponent;
  @ViewChild('ModalConcluidoProposta') modalConcluidoProposta: PsModalLoadingComponent;
  @ViewChild('ModalCarregarDadosLegadoLoading') modalCarregarDadosLegadoLoading : PsModalLoadingComponent;
  @ViewChild('ModalGeraAcordo') modalGeraAcordo: PsModalLoadingComponent;

  public bancos: Banco[];
  public formAcordo: FormGroup;
  public telefoneDevedorForm: FormGroup;
  public emailDevedorForm: FormGroup;
  public codigoRamo = 531;
  public edicaoDevedor = false;
  public InformacoesGerais = true;
  public FlagTerceiro = false;
  public Terceiro = false;
  public DadosAcordo = false;
  public Valores = false;
  public Negociacao = false;
  public CondicoesPagamento = false;
  public ConfirmarGerar = false;
  public indexEdicaoDevedor = undefined;
  public tiposRecebimento: TipoRecebimento[];
  public cadastroCongeneres: Congenere[];
  public tiposOrigem: TipoOrigemAcordo[];
  public procedenciasAcordo: ProcedenciaAcordo[];
  public formasPagamentoEntrada: FormaPagamento[];
  public formasPagamentoDemais: FormaPagamento[];
  public listaDinamicas: Dinamica[];
  public acordo: Acordo = {};
  public acordoPaginado: AcordoPaginado;
  public acordoResponse : AcordoResponse = {};
  public parcelaLista: ParcelaLista;
  public valorAtualizado: number;
  valor_do_juros: number;
  juros_a_cobrar: number;
  public parcelas: Parcela[] = [];
  public devedores: Devedor[] = [];
  private devedor: Devedor = {};
  public listaCategoriaDevedor: CategoriaDevedor[];
  public desabilitarPainelNegociacao : boolean[] = [];
  public habilitarPercentualDesconto : boolean[] = [];
  public page : Paginacao;
  public listaEscritoriosFiltro : any[];
  public nomeEscritorioFiltro : any[];
  public escritorio: Escritorio;
  public mostraAcordoFaturaRepasse= false;
  public flagVenda= false;
  public bloqueiaDadosLegado = false;
  public bloqueiaDataDivida = true;
  public bloqueiaVlrDivida = true;
  public bloqueiaEnvioBoleto = false;
  public bloqueiaNegociacaopercentualDesconto = true;
  public bloqueiaNegociacaovalorDiferencaDivida = true;
  public bloqueiaNegociacaovalorAcordo = true;
  public pagamentoBoleto = false;
  public bloqueiapercentualhonorario = true;

  public dinamicaAcordo: Dinamica[];

  public radioParcela = false;
  focus: any;
  public selected = '';
  public exibirModalBoleto = false;
  numeroSelecionado: number = 0;
  base64Pdf : string;
  valorTotalPago: number = 0;
  public produto = this.appComponent.codigoRamo;
  public codigoEscritorio: number;
  public nomeEscritorio: string;
  public isEscritorio: boolean;
  public isSerasaLoading = false;
  public dataMinimaSelecaoDemais: String;
  public dataMinimaSelecaoEntrada: String;
  private _submitted = false;
  private _submittedNovoDevedor = false;
  private _submittedScoreSerasa = false;
  //private _blockFields = true;

  private tipoAcordoSelecionado = false;

  public mostrarBotaoProposta = true;
  public mensagemErroProposta = '';

  public mask = createNumberMask({
    prefix: '',
    suffix: ' %',
    integerLimit: 3,
    includeThousandsSeparator: false,
  });

  public maskInt = createNumberMask({
    prefix: '',
    suffix: '',
    integerLimit: 5,
    includeThousandsSeparator: false,
  });

  public maskPercentage = createNumberMask({
    prefix: '',
    suffix: ' %',
    integerLimit: 3,
    includeThousandsSeparator: false,
    allowDecimal: true,
    requireDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
  });

  public maskPercentageDiscount = createNumberMask({
    prefix: '',
    suffix: ' %',
    integerLimit: 3,
    includeThousandsSeparator: false,
    allowDecimal: true,
    requireDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 4,
  });

  public maskPercentagePercentualCorrecao = createNumberMask({
    prefix: '',
    suffix: ' % a.m',
    integerLimit: 1,
    includeThousandsSeparator: false,
    allowDecimal: true,
    requireDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
  });

  pdfUrl: any;
  sinistroParametro: any;
  ramoParametro: any;
  anoSinistroParametro: any;
  itemSinistroParametro : any;
  sistemaOrigemParametro: any;
  codigoEscritorioRE: any;
  nomeEscritorioRE: any;
  codigoSucursalRE: any;
  //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
  flagSinistroItau: string;
  codigoSinistroItau: string;
  //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM

  constructor(private formBuilder: FormBuilder,
    public acordoService: AcordoService,
    public dominiosService: DominiosService,
    public parcelaService: ParcelaService,
    public propostaService: PropostaService,
    public escritorioService: EscritoriosService,
    public odmService: ODMService,
    public guiaPostalService: GuiaPostalService,
    public congenereService: CongenereService,
    public usuarioService: UsuarioService,
    private sanitizer: DomSanitizer,
    private route : ActivatedRoute,
    private router: Router,
    public devedoresService: DevedoresService,
    public contaCreditoService: ContaCreditoService,
    @Inject(AppComponent) public appComponent: AppComponent) {

  }

  ngOnInit() {
    console.log('teste Y v0.1.1');

    this.mostrarBotaoProposta = true;

    if( sessionStorage.getItem('codigoEscritorio') && sessionStorage.getItem('codigoEscritorio') != "" ) {
        this.codigoEscritorio = JSON.parse(sessionStorage.getItem('codigoEscritorio'));
    }
    this.nomeEscritorio = sessionStorage.getItem('nomeEscritorio');
    this.isEscritorio = JSON.parse(sessionStorage.getItem('isEscritorio'));

    this.route.queryParams.subscribe(params => {
      this.ramoParametro = params['codRamo'];
      this.sinistroParametro =  params['numSinistro'];
      this.anoSinistroParametro = params['anoSinistro'];
      this.itemSinistroParametro = params['numItemSinistro'];
      this.sistemaOrigemParametro = params['sistemaOrigem'];
      this.codigoSucursalRE = params['suc'];
      this.codigoEscritorioRE = params['idEscr'];
      this.nomeEscritorioRE = params['nmEsc'];
      //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
      this.flagSinistroItau = params['flagSinistroItau'];
      this.codigoSinistroItau = params['numeroSinistroItau'];
      //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
    });

    if(this.ramoParametro != undefined) {
      this.codigoRamo = Number(this.ramoParametro);
    }

    this.inicializarDadosAcordo();
    this.criarFormulario(this.acordo);

    this.carregarDadosPagina();

    this.desabilitarPainelNegociacao[0] = false;
    this.desabilitarPainelNegociacao[1] = false;
    this.desabilitarPainelNegociacao[2] = false;
    this.habilitarPercentualDesconto[0] = false;
    this.habilitarPercentualDesconto[1] = false;
    this.habilitarPercentualDesconto[2] = false;

    //carregar as combobox
    this.carregarBanco();
    this.carregarDinamica();
    this.carregarFormasPagamentoEntrada();
    this.carregarFormasPagamentoDemais();
    this.carregarCategoriaDevedores();
    this.carregarCadastroCongeneres();

    if(this.sinistroParametro != undefined && this.ramoParametro != undefined
        && this.anoSinistroParametro != undefined && this.sistemaOrigemParametro != undefined) {

      this.formAcordo.controls['codigoRamoSinistro'].setValue(this.ramoParametro);
      this.formAcordo.controls['numeroSinistro'].setValue(this.sinistroParametro);
      this.formAcordo.controls['anoSinistro'].setValue(this.anoSinistroParametro);
      this.formAcordo.controls['sequenciaItemSinistro'].setValue(this.itemSinistroParametro);
      this.formAcordo.controls['sistemaOrigem'].setValue(this.sistemaOrigemParametro);

      var params : PropostaService.ObterProcessoRessarcimentoParams = {
        ramoSinistro:this.ramoParametro,
        anoSinistro:this.anoSinistroParametro,
        numeroSinistro:this.sinistroParametro,
        sequenciaItemSinistro:this.itemSinistroParametro,
        sistemaOrigem:this.sistemaOrigemParametro,
        codigoEscritorio:this.codigoEscritorioRE
      };

      this.modalCarregarDadosLegadoLoading.open(null);
      this.propostaService.obterProcessoRessarcimento(params).subscribe(result => {
        if (result.acordos != undefined && result.acordos.length > 0){
            console.log("Carregando acordo do LEGADO: "+ JSON.stringify(result));
            this.carregarAcordo(result.acordos[0]);
            this.pesquisarAcordos(this.page, result.acordos[0]);
            this.bloqueiaCamposLegado();
            console.log('dt div'+this.formAcordo.controls['dataDivida'].value);
            console.log('vlr div'+this.formAcordo.controls['valorAtualDivida'].value);
            this.modalCarregarDadosLegadoLoading.close();
        }
      }, error => {
        this.modalCarregarDadosLegadoLoading.close();
        console.log('Erro ao consultar processo de ressarcimento no sistema de origem!' + error);
        if (error.indexOf("Unauthorized") > 0) {
          this.appComponent.createAlert('Perfil não possui acesso a aplicação, favor verificar com administrador', 'error');
        } else {
          this.appComponent.createAlert('Ocorreu um erro ao carregar as informações do Legado. Por favor tente mais tarde.', 'error');
        }
      });
    }

    this.verificaEnvioBoletoMensalmente();
  }

  carregarDadosPagina() {
    this.usuarioService.recuperarDadosUsuario().subscribe(result => {
        this.codigoRamo = result.produto;
        this.acordo.codigoRamoOrigemAcordo = this.codigoRamo;

        this.carregarTiposRecebimento( result.produto );
        this.carregarTiposOrigem( result.produto );

        this.carregarProcedenciasAcordo( result.produto );

        this.formAcordo.controls['codigoRamoSinistro'].setValue( result.produto );
        this.formAcordo.controls['codigoRamoOrigemAcordo'].setValue( result.produto );

        if (this.codigoRamo == 746) {
            this.formAcordo.controls['sequenciaItemSinistro'].setValue(0);
        }

        if (this.codigoRamo == 531) {
          //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
          //this.formAcordo.controls['codigoMarca'].setValue(1);
          if(this.flagSinistroItau != undefined && this.flagSinistroItau != null && this.flagSinistroItau == 'S') {
            this.formAcordo.controls['codigoMarca'].setValue(3);
            this.formAcordo.controls['codigoSinistroItau'].setValue(this.codigoSinistroItau);
          } else {
            this.formAcordo.controls['codigoMarca'].setValue(1);
          }
          //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
        }

        if( result.codigoEscritorio ) {
            this.codigoEscritorio = result.codigoEscritorio;
        }

        if( result.nomeEscritorio ) {
            this.nomeEscritorio = result.nomeEscritorio;
        }

        this.isEscritorio = result.flagEscritorio;

        if( this.isEscritorio ) {
            this.formAcordo.controls['codigoEscritorio'].setValue( result.codigoEscritorio );
            this.formAcordo.controls['escritorio'].setValue( result.nomeEscritorio );
        }
    });
  }

  private pesquisarAcordos(page, acordo:Acordo){
    this.parcelaService.obterParcelasPorNumeroSinistro(this.sinistroParametro).subscribe(response => {
      console.log('Buscando valor recuperado do sinistro: ' + this.sinistroParametro);
      this.parcelaLista = response;
      let parcelas = this.parcelaLista.parcelas;

      for (let i = 0; i < parcelas.length; i++) {
          this.valorTotalPago = this.valorTotalPago +
          parcelas[i].valorParcelaSemJuros +
          parcelas[i].valorParcelaJuros +
          parcelas[i].valorHonorarioPago;
      }
      //this.atualizarValorRecuperado();
    }, error => {
      console.log('O metodo obterParcelasPorNumeroSinistro não encontrou registros para o sinistro informado');
    });
  }

  private atualizarValorRecuperado(){
    if( this.codigoRamo === 531 ) {
      this.formAcordo.controls['valorRecuperado'].setValue(this.formAcordo.value['valorRecuperado'] + this.valorTotalPago);
    } else if( this.codigoRamo === 746 ) {
      this.formAcordo.controls['valorRecuperado'].setValue(this.formAcordo.value['valorRecuperado'] + this.valorTotalPago);
    }
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio : this.formAcordo.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(
        data => {
            this.listaEscritoriosFiltro = data;
            for (let key in data) {
              this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
            }
        }
      );

      return of(this.nomeEscritorioFiltro);
    };
  }

  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;

    for (let key in this.listaEscritoriosFiltro) {
      if(this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected){
        this.formAcordo.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  private carregarTiposRecebimento(produto: number): void {
    var params: DominiosService.ObterTiposRecebimentoPorRamoParams = {
      codigoRamo: produto,
      origemAcessoWorkflow: this.appComponent.origemAcessoWorkflow
    };

    this.dominiosService.obterTiposRecebimentoPorRamo(params).subscribe(result => {
      this.tiposRecebimento = result;
      if (produto == 531) {
        this.tiposRecebimento = this.tiposRecebimento.filter(function(codtiprecebimento) {
          return codtiprecebimento.codigoTipoRecebimento != 8;
        })
      }
    });
  }

  private carregarBanco(): void {
    this.contaCreditoService.obterDadosFinanceirosBancos().subscribe(result => {
      this.bancos = result;
    });
  }

  private carregarDinamica(): void {
    this.dominiosService.obterListaDinamicasJuridico().subscribe(result => {
      this.listaDinamicas = result;
    });
  }
  private carregarCadastroCongeneres(): void {
    this.congenereService.obterCadastroCongeneres().subscribe(result => {
      this.cadastroCongeneres = result;
    });
  }

  private carregarTiposOrigem(produto: number): void {
    this.dominiosService.obterTiposOrigemAcordoPorRamo( produto ).subscribe(result => {
      this.tiposOrigem = result;
    });
  }

  private carregarProcedenciasAcordo(produto: number): void {
    this.dominiosService.obterProcedenciasAcordoPorRamo( produto ).subscribe(result => {
      this.procedenciasAcordo = result;
    });
  }

  private carregarFormasPagamentoEntrada(): void {
    var boleto: FormaPagamento = {};
    boleto.codigoFormaPagamento = 1;
    boleto.nomeFormaPagamento = "Boleto";
    boleto.siglaFormaPagamento = "Boleto";

    var fatura: FormaPagamento = {};
    fatura.codigoFormaPagamento = 2;
    fatura.nomeFormaPagamento = "Fatura/Repasse";
    fatura.siglaFormaPagamento = "Fatura/Repasse";

    var credito: FormaPagamento = {};
    credito.codigoFormaPagamento = 3;
    credito.nomeFormaPagamento = "Crédito em conta";
    credito.siglaFormaPagamento = "Crédito em conta";

    var debito: FormaPagamento = {};
    debito.codigoFormaPagamento = 4;
    debito.nomeFormaPagamento = "Débito em conta";
    debito.siglaFormaPagamento = "Débito em conta";

    this.formasPagamentoEntrada = [];
    this.formasPagamentoEntrada.push( boleto );
    this.formasPagamentoEntrada.push( credito );
    this.formasPagamentoEntrada.push( debito );

    if( this.formAcordo.value['codigoTipoRecebimento'] == 11 || this.formAcordo.value['codigoTipoRecebimento'] == 12 ) {
        this.mostraAcordoFaturaRepasse = true;
        this.formasPagamentoEntrada.push( fatura );
    }
  }

  private carregarFormasPagamentoDemais(): void {
    var boleto: FormaPagamento = {};
    boleto.codigoFormaPagamento = 1;
    boleto.nomeFormaPagamento = "Boleto";
    boleto.siglaFormaPagamento = "Boleto";

    var fatura: FormaPagamento = {};
    fatura.codigoFormaPagamento = 2;
    fatura.nomeFormaPagamento = "Fatura/Repasse";
    fatura.siglaFormaPagamento = "Fatura/Repasse";

    var credito: FormaPagamento = {};
    credito.codigoFormaPagamento = 3;
    credito.nomeFormaPagamento = "Crédito em conta";
    credito.siglaFormaPagamento = "Crédito em conta";

    var debito: FormaPagamento = {};
    debito.codigoFormaPagamento = 4;
    debito.nomeFormaPagamento = "Débito em conta";
    debito.siglaFormaPagamento = "Débito em conta";

    this.formasPagamentoDemais = [];

    if( this.formAcordo.value['codigoFormaPagamentoEntrada'] == 4 ) {
        this.formasPagamentoDemais.push( debito );
    } else {
        this.formasPagamentoDemais.push( boleto );
        this.formasPagamentoDemais.push( credito );

        if( this.formAcordo.value['codigoFormaPagamentoEntrada'] == null || !this.formAcordo.value['codigoFormaPagamentoEntrada'] ) {
            this.formasPagamentoDemais.push( debito );
        }

        if( this.formAcordo.value['codigoTipoRecebimento'] == 11 || this.formAcordo.value['codigoTipoRecebimento'] == 12 ) {
            this.mostraAcordoFaturaRepasse = true;
            this.formasPagamentoDemais.push( fatura );
        }
    }
  }

  private carregarCategoriaDevedores(): void {
    this.dominiosService.obterListaCategoriaDevedor().subscribe(result => {
      this.listaCategoriaDevedor = result;
    });
  }

  public getSubmitted() {
    return this._submitted;
  }

  public getSubmittedDevedor() {
    return this._submittedNovoDevedor;
  }

  private calcularValorDivida(tipoCalculo: TipoCalculoDividaEnum) {
    var valorAtualizadoCalculo: number =  0.00;
    // if( this.formAcordo.value['lmi'] && Number(this.formAcordo.getRawValue().valorAtualizado) > Number(this.formAcordo.getRawValue().lmi) ) {
    //     this.formAcordo.controls['valorAtualizado'].setValue( this.formAcordo.value['lmi'] );
    // }

    if( this.formAcordo.value['desmembramento']   && Number(this.formAcordo.getRawValue().desmembramento) > Number(this.formAcordo.getRawValue().valorAtualizado) ) {
       this.formAcordo.controls['desmembramento'].setValue( 0 );
     }

    if(this.formAcordo.value['valorAtualDivida'] <= 0){
        return;
    }
    console.log('valorAtualizado'+this.formAcordo.getRawValue().valorAtualizado);
    console.log('valorAtualizadoOriginal'+this.formAcordo.getRawValue().valorAtualizadoOriginal);
    console.log('valorAtualizadoDiferencaOriginal'+this.formAcordo.getRawValue().valorAtualizadoDiferencaOriginal);
    var dadosCalculo: DadosCalculoDivida = {};
    dadosCalculo.tipoCalculo = tipoCalculo;
    dadosCalculo.codigoRamo = this.appComponent.codigoRamo;
    dadosCalculo.dataDivida = moment(this.formAcordo.value['dataDivida'], "DD/MM/YYYY").format("YYYY-MM-DD");
    dadosCalculo.percentualDesconto = this.getPercentualDesconto();
    dadosCalculo.percentualHonorario = Number(this.getValorPercentual(this.formAcordo.value['percentualHonorario']));
    dadosCalculo.tipoAcordo = this.formAcordo.value['codigoTipoRecebimento'];
    dadosCalculo.codigoProcedencia = this.formAcordo.value['codigoProcedencia'];
    dadosCalculo.valorAcordo = Number(this.formAcordo.value['valorAcordo']);
    dadosCalculo.valorRecuperado = Number(this.formAcordo.value['valorRecuperado']);
    dadosCalculo.valorAtualizado = Number(this.formAcordo.getRawValue().valorAtualizado);
    dadosCalculo.valorAtualizadoOriginal = Number(this.formAcordo.getRawValue().valorAtualizadoOriginal);
    dadosCalculo.valorAtualizadoDiferencaOriginal = Number(this.formAcordo.getRawValue().valorAtualizadoDiferencaOriginal);
    dadosCalculo.valorDesconto = Number(this.formAcordo.value['valorDiferencaDivida']);
    dadosCalculo.valorHonorario = Number(this.formAcordo.value['valorDiferencaComHonorario']);
    dadosCalculo.valorPrejuizo = Number(this.formAcordo.value['valorAtualDivida']);
    dadosCalculo.percentualCorrecaoNegociacao = this.getPercentualCorrecaoNegociacao();
    dadosCalculo.valorVendaSalvados = this.formAcordo.value['valorVendaSalvado'];
    console.log('SALVADO'+this.formAcordo.value['valorVendaSalvado'])
    dadosCalculo.valorDespesasCustas = this.formAcordo.value['despesasCustas'];
    dadosCalculo.valorDescontoDespesasCustas = this.formAcordo.value['descontoDespesasCustas'];
    dadosCalculo.lmi = this.formAcordo.value['lmi'];
    dadosCalculo.desmembramento = this.formAcordo.value['desmembramento'];
    dadosCalculo.lmiRaw = this.formAcordo.getRawValue().lmi;
    dadosCalculo.desmembramentoRaw = this.formAcordo.getRawValue().desmembramento;
    dadosCalculo.valorAtualizadoRaw = this.formAcordo.getRawValue().valorAtualizado;
    console.log(' this.formAcordo.getRawValue().lmi'+ this.formAcordo.getRawValue().lmi);
    console.log('this.formAcordo.getRawValue().desmembramento'+this.formAcordo.getRawValue().desmembramento);
    console.log('this.formAcordo.getRawValue().valorAtualizado'+this.formAcordo.getRawValue().valorAtualizado);
    console.log('this.formAcordo.value[lmi]'+this.formAcordo.value['lmi']);
    console.log('this.formAcordo.value[desmembramento]'+this.formAcordo.value['desmembramento']);

    this.propostaService.calcularDivida(dadosCalculo).subscribe(response => {
      this.formAcordo.controls['valorAtualizado'].setValue(response.valorAtualizado);
      this.formAcordo.controls['valorAtualizadoOriginal'].setValue(response.valorAtualizadoOriginal);
      this.formAcordo.controls['valorAtualizadoDiferencaOriginal'].setValue(response.valorAtualizadoDiferencaOriginal);
      this.formAcordo.controls['percentualDesconto'].setValue(
            Number(response.percentualDesconto).toFixed(4).toString().replace('.', ','));
      this.formAcordo.controls['percentualHonorario'].setValue(response.percentualHonorario);
      this.formAcordo.controls['valorAcordo'].setValue(Number(response.valorAcordo).toFixed(2));
      this.formAcordo.controls['valorDiferencaDivida'].setValue(response.valorDesconto);
      this.formAcordo.controls['valorAtualDivida'].setValue(response.valorPrejuizo);
      this.formAcordo.controls['valorDiferencaComHonorario'].setValue(response.valorHonorario);
      this.formAcordo.controls['valorAtualizadoComDesconto'].setValue(
            response.valorAtualizado - response.valorDesconto);
      this.formAcordo.controls['despesasCustas'].setValue(response.valorDespesasCustas);
      this.formAcordo.controls['descontoDespesasCustas'].setValue(response.valorDescontoDespesasCustas);
      this.formAcordo.controls['desmembramento'].setValue(response.desmembramento);
      // if( this.formAcordo.value['lmi'] && Number(this.formAcordo.getRawValue().valorAtualizado) > Number(this.formAcordo.getRawValue().lmi) ) {
      //   this.formAcordo.controls['valorAtualizado'].setValue( this.formAcordo.value['lmi'] );
      //   console.log('valoratualizadoRAW'+this.formAcordo.getRawValue().valorAtualizado);
      // }

    }, erroOcorrido => {
      if (erroOcorrido.status == 400 &&
        this.formAcordo.value['dataDivida'] == null) {
        this.appComponent.createAlert("Por favor, selecione a data da dívida!", "alert");
      } else if (erroOcorrido.status == 412) {
        this.appComponent.createAlert(erroOcorrido.error.mensagemValidacao, "alert");
        this.zerarValoresDesconto();
      } else {
        this.appComponent.createAlert("Ocorreu um erro no calculo da dívida!", "error");
      }
    });
  }

  private zerarValoresDesconto() {
    console.log("Zerando valores de desconto...");
    this.formAcordo.controls['percentualDesconto'].setValue('0,0');
    this.formAcordo.controls['valorDiferencaDivida'].setValue(0);
    this.formAcordo.controls['valorAcordo'].setValue(Number(this.formAcordo.getRawValue().valorAtualizado));
    this.formAcordo.controls['descontoDespesasCustas'].setValue(0);
  }

  public validarProcedenciaRecalcularValoresDivida() {
     this.formAcordo.controls['valorAtualizadoDiferencaOriginal'].setValue(0);

    this.combosEmissaoAcordoAlterado();
    this.calcularValorAtualizado();
    this.atualizarValorAcordoPeloPercentualDesconto();
  }

  private inicializarDadosAcordo(): void {
    this.acordo.codigoRamoOrigemAcordo = this.codigoRamo;
    this.acordo.processoRessarcimento = {};
    this.acordo.procedencia = {};
    this.acordo.tipoRecebimento = {};
    this.acordo.tipoOrigemAcordo = {};
    this.acordo.auditoria = {};
  }

  private criarObjetoAcordo(): void {
    this.inicializarDadosAcordo();

    this.acordo.codigoMarca = this.formAcordo.value['codigoMarca'];
    this.acordo.processoRessarcimento.codigoRamoSinistro = this.formAcordo.value['codigoRamoSinistro'];
    this.acordo.processoRessarcimento.anoSinistro = this.formAcordo.value['anoSinistro'];
    this.acordo.processoRessarcimento.numeroSinistro = this.formAcordo.value['numeroSinistro'];
    this.acordo.processoRessarcimento.sequenciaItemSinistro = this.formAcordo.value['sequenciaItemSinistro'];
    this.acordo.processoRessarcimento.codigoSucursal = this.formAcordo.value['codigoSucursal'];
    //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
    this.acordo.processoRessarcimento.codigoSinistroItau = this.formAcordo.value['codigoSinistroItau'];
    //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
    this.acordo.codigoEscritorio = this.formAcordo.value['codigoEscritorio'];
    this.acordo.nomeEscritorio = this.formAcordo.value['escritorio'];
    this.acordo.procedencia.codigoProcedencia = this.formAcordo.value['codigoProcedencia'];
    this.acordo.tipoRecebimento.codigoTipoRecebimento = this.formAcordo.value['codigoTipoRecebimento'];
    this.acordo.tipoOrigemAcordo.codigoTipoOrigem = this.formAcordo.value['codigoTipoOrigem'];
    this.acordo.valorAtualDivida = Number(this.formAcordo.value['valorAtualDivida']);
    this.acordo.valorAcordo = Number(this.formAcordo.value['valorAcordo']);
    this.acordo.valorRecuperado = Number(this.formAcordo.value['valorRecuperado']);
    this.acordo.valorDiferencaDivida = Number(this.formAcordo.value['valorDiferencaDivida']);
    this.acordo.valorDesconto = Number(this.formAcordo.value['valorDesconto']);
    this.acordo.percentualDesconto = this.getPercentualDesconto();
    this.acordo.percentualHonorarioFlutuante = Number(this.getValorPercentual(this.formAcordo.value['percentualHonorarioFlutuante']));
    this.acordo.dataDivida = moment(this.formAcordo.value['dataDivida'], "YYYY-MM-DD").format("YYYY-MM-DD");
    this.acordo.percentualHonorario = Number(this.getValorPercentual(this.formAcordo.value['percentualHonorario']));
    this.acordo.flagCobradaCorrecaoMonetaria = this.getPercentualCorrecaoNegociacao() > 0 ? "S" : "N";
    this.acordo.valorSalvados = this.formAcordo.value['valorVendaSalvado'];
    this.acordo.despesasCustas = this.formAcordo.value['despesasCustas'];
    this.acordo.descontoDespesasCustas = this.formAcordo.value['descontoDespesasCustas'];
    this.acordo.dinamica = this.formAcordo.value['dinamica'];
    this.acordo.textoJustificativaCriacao = this.formAcordo.value['textoJustificativaCriacao'];

    this.acordo.percentualTaxaJuro = 0;
    this.acordo.percentualTaxaJuroParcela = 0;
    this.acordo.flagPropostaAcordo = AppConstantes.FLAG_SIM;

    if(this.formAcordo.value['flagEnvioBoletoMensal']){
        this.acordo.flagEnvioBoletoMensal = AppConstantes.FLAG_SIM;
    } else {
        this.acordo.flagEnvioBoletoMensal = AppConstantes.FLAG_NAO;
    }

    //TODO setar campos depois corretamente
    this.acordo.valorDespesaProcesso = 0;
    this.acordo.valorRessarcimentoRealizado = 0;
    this.acordo.valorProvisionamento = 0;

    this.acordo.flagAcordoEscalonado = AppConstantes.FLAG_NAO;
    if (this.formAcordo.value['checkboxgAcordoEscalonado']) {
      this.acordo.flagAcordoEscalonado = AppConstantes.FLAG_SIM;
    }

    let cobrarJuros = AppConstantes.FLAG_NAO;
    if (this.formAcordo.value['checkboxComJuros']) {
      cobrarJuros = AppConstantes.FLAG_SIM;
    }
  }

  private criarFormulario(acordo: Acordo) {
    this.formAcordo = this.formBuilder.group({
      codigoRamoOrigemAcordo: null,
      codigoRamoSinistro: null,
      numeroSinistro: [acordo.processoRessarcimento.numeroSinistro],
      anoSinistro: [acordo.processoRessarcimento.anoSinistro],
      sequenciaItemSinistro: [acordo.processoRessarcimento.sequenciaItemSinistro],
      codigoSucursal: [acordo.processoRessarcimento.codigoSucursal],
      //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
      codigoSinistroItau: [acordo.processoRessarcimento.codigoSinistroItau],
      //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
      codigoEscritorio: this.codigoEscritorio != null ? this.codigoEscritorio : [acordo.codigoEscritorio],
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : [acordo.nomeEscritorio],
      codigoTipoRecebimento: [acordo.tipoRecebimento.codigoTipoRecebimento],
      codigoProcedencia: [acordo.procedencia.codigoProcedencia],
      codigoTipoOrigem: [acordo.tipoOrigemAcordo.codigoTipoOrigem],
      flagAcordoEscalonado: [acordo.flagAcordoEscalonado],
      dataDivida: [acordo.dataDivida],
      valorAtualDivida: [acordo.valorAtualDivida],
      valorAcordo: [acordo.valorAcordo],
      valorRecuperado: [acordo.valorRecuperado],
      valorAtualizado: [null],
      valorAtualizadoOriginal: [null],
      valorAtualizadoDiferencaOriginal: 0.00,
      valorAtualizadoSave: Number,
      valorDesconto: [acordo.valorDesconto],
      valorDiferencaDivida: [acordo.valorDiferencaDivida],
      valorDiferencaComHonorario: [null],
      valorAtualizadoComDesconto: [null],
      percentualHonorarioFlutuante: [acordo.percentualHonorarioFlutuante],
      percentualHonorario: [acordo.percentualHonorario],
      percentualDesconto: [acordo.percentualDesconto],
      percentualTaxaJuro: [acordo.percentualTaxaJuro],
      percentualTaxaJuroParcela: [acordo.percentualTaxaJuroParcela],
      qtdParcelas: [null],
      dataVencimentoEntrada: [null],
      dataPrimeiroVencimento: [null],
      valorEntrada: [null],
      valorHonorarioEntrada: [null],
      valorVendaSalvado: [acordo.valorSalvados],
      codigoFormaPagamentoEntrada: [null],
      formaPagamentoEntrada: [null],
      checkboxComJuros: [null],
      percentualJurosParcela: [null],
      checkboxgAcordoEscalonado: [null],
      percentualCorrecaoNegociacao: [null],
      codigoFormaPagamento: [null],
      radioEntrada: [null],
      parcelasForm: this.formBuilder.array([]),
      nomeNovoDevedor: [''],
      scoreDevedor: Number,
      probInadimDevedor: Number,
      cpfNovoDevedor: ['', PsCPFValidator()],
      cnpjNovoDevedor: ['', CnpjAlfanumericoValidator.validar()],
      telNovoDevedor: [''],
      emailNovoDevedor: [''],
      negativadoNovoDevedor: [''],
      congenereNovoDevedor: [''],
      codigoEndereco: Number,
      cepNovoDevedor: [''],
      tipoEnderecoNovoDevedor: [''],
      enderecoNovoDevedor: [''],
      numeroNovoDevedor: [''],
      complementoNovoDevedor: [''],
      bairroNovoDevedor: [''],
      cidadeNovoDevedor: [''],
      estadoNovoDevedor: [''],
      codigoCategoriaDevedor: [null],
      nomeCongenere: [''],
      flagPagador: [null],
      nomeCategoriaDevedor: [''],
      tipoPessoa: ['0'],
      descontoDespesasCustas: [''],
      despesasCustas: [''],
      codigoMarca: [''],
      dinamica: [''],
      urlBoleto: [''],
      textoJustificativaCriacao: [''],
      telefonesDevedor: this.formBuilder.array([]),
      emailsDevedor: this.formBuilder.array([]),
      sistemaOrigem: Number,
      flagEnvioBoletoMensal: [null],
      banco: [null],
      agencia: [null],
      conta: [null],
      lmi: [null],
      desmembramento: [0],
    });


  }

  public abrirModalJustificativa(evento) {
    console.log("Abrindo modal de justificativa");
  }

  onFecharModalJustificativa() {
    console.log("Fechando Modal");

  }
  public onAbrirModal(evento) {
    console.log("Abrindo modal de devedores... ");
    if (!this.edicaoDevedor) {
      this.limparDadosDevedor();
    }
  }

  private limparDadosDevedor() {

    this.formAcordo.controls['nomeNovoDevedor'].setValue(null);
    this.formAcordo.controls['cpfNovoDevedor'].setValue('');
    this.formAcordo.controls['cnpjNovoDevedor'].setValue('');
    this.formAcordo.controls['scoreDevedor'].setValue(null);
    this.formAcordo.controls['probInadimDevedor'].setValue(null);
    this.formAcordo.controls['negativadoNovoDevedor'].setValue(null);
    this.formAcordo.controls['congenereNovoDevedor'].setValue(null);
    this.formAcordo.controls['cepNovoDevedor'].setValue(null);
    this.formAcordo.controls['tipoEnderecoNovoDevedor'].setValue(null);
    this.formAcordo.controls['enderecoNovoDevedor'].setValue(null);
    this.formAcordo.controls['numeroNovoDevedor'].setValue(null);
    this.formAcordo.controls['complementoNovoDevedor'].setValue(null);
    this.formAcordo.controls['bairroNovoDevedor'].setValue(null);
    this.formAcordo.controls['cidadeNovoDevedor'].setValue(null);
    this.formAcordo.controls['estadoNovoDevedor'].setValue(null);

    var telefonesArray = this.formAcordo.get('telefonesDevedor') as FormArray;
    while (telefonesArray.length !== 0) {
      telefonesArray.removeAt(0);
    }

    var emailsArray = this.formAcordo.get('emailsDevedor') as FormArray;
    while (emailsArray.length !== 0) {
      emailsArray.removeAt(0);
    }
  }

  public onFecharModal() {
    console.log("Fechando modal... ");
    this.edicaoDevedor = false;
    this.indexEdicaoDevedor = undefined;
  }

  private validarFormulario(): boolean {
    var isErroValidacao = false;
    let isCampoFocus = false;

    if (!this.formAcordo.value['codigoRamoSinistro']) {
      this.formAcordo.controls['codigoRamoSinistro'].setErrors({ 'incorrect': true });
      document.getElementById('codigoRamoSinistro').focus();
      isCampoFocus = true;
    }
    if (!this.formAcordo.value['numeroSinistro']) {
      this.formAcordo.controls['numeroSinistro'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('numeroSinistro').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['anoSinistro']) {
      this.formAcordo.controls['anoSinistro'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('anoSinistro').focus(); isCampoFocus = true };
    }


    if (this.formAcordo.value['codigoRamoOrigemAcordo'] != 746) {
      if (!this.formAcordo.value['sequenciaItemSinistro'] && this.formAcordo.value['sequenciaItemSinistro'] != 0) {
        this.formAcordo.controls['sequenciaItemSinistro'].setErrors({ 'incorrect': true });
        if (!isCampoFocus && document.getElementById('sequenciaItemSinistro') !== null) { document.getElementById('sequenciaItemSinistro').focus(); isCampoFocus = true };
      }
    }else {this.formAcordo.controls['sequenciaItemSinistro'].setValue(0);}

    if (!this.formAcordo.value['codigoSucursal']) {
      this.formAcordo.controls['codigoSucursal'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('codigoSucursal').focus(); isCampoFocus = true };
    }

    if (!this.formAcordo.value['codigoProcedencia']) {
      this.formAcordo.controls['codigoProcedencia'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('codigoProcedencia').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['codigoTipoRecebimento']) {
      this.formAcordo.controls['codigoTipoRecebimento'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('codigoTipoRecebimento').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['codigoTipoOrigem']) {
      this.formAcordo.controls['codigoTipoOrigem'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('codigoTipoOrigem').focus(); isCampoFocus = true };
    }
    if (this.formAcordo.value['codigoTipoOrigem'] == 1 && !this.formAcordo.value['nomeCongenere']) {
      this.formAcordo.controls['nomeCongenere'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        // ps-autocomplete gera uma div e um input sem id e name dentro - por isso foi utilizado firstElementChild
        let element: HTMLElement = document.getElementById('nomeCongenere').firstElementChild.firstElementChild as HTMLElement;
        element.focus();
        isCampoFocus = true
      };
    }
    if (document.getElementById('lmi') != null && this.formAcordo.value['codigoTipoOrigem'] == 1 && !this.formAcordo.value['lmi']) {
        this.formAcordo.controls['lmi'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) { document.getElementById('lmi').focus(); isCampoFocus = true };
      }
      //if (this.formAcordo.value['codigoTipoOrigem'] == 1 && !this.formAcordo.value['desmembramento']) {
      //  this.formAcordo.controls['desmembramento'].setErrors({ 'incorrect': true });
      //  if (!isCampoFocus) { document.getElementById('desmembramento').focus(); isCampoFocus = true };
     // }
    if (!this.formAcordo.value['dataDivida']) {
      this.formAcordo.controls['dataDivida'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('dataDivida').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['valorAtualDivida']) {
      this.formAcordo.controls['valorAtualDivida'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('valorAtualDivida').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['valorAcordo']) {
      this.formAcordo.controls['valorAcordo'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('valorAcordo').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['valorAtualizadoSave']) {
      this.formAcordo.controls['valorAtualizadoSave'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('valorAtualizadoSave').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['radioEntrada']) {
      this.formAcordo.controls['radioEntrada'].setErrors({ 'incorrect': true });
      //if (!isCampoFocus) {document.getElementById('radioEntrada').focus(); isCampoFocus = true};
    } else if (this.formAcordo.value['radioEntrada'] === '1') {
      if (!this.formAcordo.value['valorEntrada']) {
        this.formAcordo.controls['valorEntrada'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) { document.getElementById('valorEntrada').focus(); isCampoFocus = true };
      }
      if (!this.formAcordo.value['codigoFormaPagamentoEntrada']) {
        this.formAcordo.controls['codigoFormaPagamentoEntrada'].setErrors({ 'incorrect': true });
        if (!isCampoFocus && document.getElementById('codigoFormaPagamentoEntrada') !== null) { document.getElementById('codigoFormaPagamentoEntrada').focus(); isCampoFocus = true };
      }
      if (!this.formAcordo.value['dataVencimentoEntrada']) {
        this.formAcordo.controls['dataVencimentoEntrada'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) { document.getElementById('dataVencimentoEntrada').focus(); isCampoFocus = true };
      }
    } else if (this.formAcordo.value['radioEntrada'] === '3') {
      if (!this.formAcordo.value['valorEntrada']) {
        this.formAcordo.controls['valorEntrada'].setErrors({ 'incorrect': true });
        if (!isCampoFocus && document.getElementById('valorEntrada') !== null) { document.getElementById('valorEntrada').focus(); isCampoFocus = true };
      }
      if (!this.formAcordo.value['codigoFormaPagamentoEntrada']) {
        this.formAcordo.controls['codigoFormaPagamentoEntrada'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) { document.getElementById('codigoFormaPagamentoEntrada').focus(); isCampoFocus = true };
      }
      if (!this.formAcordo.value['dataVencimentoEntrada']) {
        this.formAcordo.controls['dataVencimentoEntrada'].setErrors({ 'incorrect': true });
        if (!isCampoFocus && document.getElementById('codigoFormaPagamentoEntrada') !== null) { document.getElementById('dataVencimentoEntrada').focus(); isCampoFocus = true };
      }
    }

    if (!this.formAcordo.value['codigoFormaPagamento'] && this.formAcordo.value['radioEntrada'] != 3) {
      this.formAcordo.controls['codigoFormaPagamento'].setErrors({ 'incorrect': true });
      if (!isCampoFocus   && document.getElementById('codigoFormaPagamento') !== null) { document.getElementById('codigoFormaPagamento').focus(); isCampoFocus = true };
    }
    if (!this.formAcordo.value['dataPrimeiroVencimento'] && this.formAcordo.value['radioEntrada'] != 3) {
      this.formAcordo.controls['dataPrimeiroVencimento'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) { document.getElementById('dataPrimeiroVencimento').focus(); isCampoFocus = true };
    }

    if( ( this.formAcordo.value['codigoFormaPagamentoEntrada'] && this.formAcordo.value['codigoFormaPagamentoEntrada'] == 4 ) || ( this.formAcordo.value['codigoFormaPagamento'] && this.formAcordo.value['codigoFormaPagamento'] == 4 ) ) {
        if( !this.formAcordo.value['banco']) {
            this.formAcordo.controls['banco'].setErrors({ 'incorrect': true });
            if (!isCampoFocus) { document.getElementById('banco').focus(); isCampoFocus = true };
        }
        if( !this.formAcordo.value['agencia']) {
            this.formAcordo.controls['agencia'].setErrors({ 'incorrect': true });
            if (!isCampoFocus) { document.getElementById('agencia').focus(); isCampoFocus = true };
        }
        if( !this.formAcordo.value['conta']) {
            this.formAcordo.controls['conta'].setErrors({ 'incorrect': true });
            if (!isCampoFocus) { document.getElementById('conta').focus(); isCampoFocus = true };
        }

        if (this.formAcordo.value['checkboxComJuros']) {
          console.log('valida percentual juros parcela')     ;
          if (!this.formAcordo.value['percentualJurosParcela']) {
            this.formAcordo.controls['percentualJurosParcela'].setErrors({ 'incorrect': true });
            if (!isCampoFocus && document.getElementById('percentualJurosParcela') !== null) { document.getElementById('percentualJurosParcela').focus(); isCampoFocus = true };
          }
        }
    }

    if (!this.devedores || this.devedores.length < 1) {
      this.setMensagemAlert('', 'Informe o cadastro do devedor.');
      isErroValidacao = true;
      if (!isCampoFocus) { document.getElementById('btnNovoDevedor').focus(); isCampoFocus = true };
    }

    this.pagadorSelecionadoChecked()

    if (this.devedores && this.devedores.length > 0) {
      var isPagadorSelecionado = false;
      for (var i = 0; i < this.devedores.length; i++) {
        if (this.devedores[i].flagPagador) {
          isPagadorSelecionado = true;
          this.FlagTerceiro = true;
          break;
        }
        
        let element: HTMLInputElement = document.getElementsByName("radioPagador")[i] as HTMLInputElement;
        if (element.checked) {
          this.devedores[i].flagPagador = true;
          isPagadorSelecionado = true;
          this.FlagTerceiro = true;
          break;
        }
        
      }

      if (!isPagadorSelecionado) {
        this.setMensagemAlert('', 'Selecione o Pagador.');
        isErroValidacao = true;
        this.FlagTerceiro = false;
      }
    }

    return isErroValidacao;
  }

    public pagadorSelecionadoChecked() {
    // a diretiva ps-form-radio gera componentes com id dinamico, por conta disso foi necessario pegar assim o primeiro elemento
    let element: HTMLInputElement = document.getElementsByName("radioPagador")[0] as HTMLInputElement;
    if(this.devedores.length == 1) {
      for (var index = 0; index < this.devedores.length; index++) {
        this.devedores[index].flagPagador = true;
        element.checked = true;
        this.FlagTerceiro = true;
      }
    }
  }

  private verificarValidacoesNaoCpfCnpj() : boolean {
    var isErroOutroCampo = false;

    Object.keys(this.formAcordo.controls).forEach(key => {
      if(this.formAcordo.controls[key].status === 'INVALID' &&
         (!this.formAcordo.controls[key].errors.cpf &&
         !this.formAcordo.controls[key].errors.cnpj)){
          isErroOutroCampo = true;
      }
    });

    return isErroOutroCampo;
  }
  public dadoAcordoChanged() {
    if(this.codigoRamo == 746) {
    this.tipoAcordoSelecionado = (this.formAcordo.value['codigoTipoRecebimento'] != "");
    }
    if(this.codigoRamo == 531) {
      if ((this.formAcordo.controls['codigoProcedencia'].value == null || this.formAcordo.controls['codigoProcedencia'].value == '') || (this.formAcordo.controls['codigoTipoOrigem'].value == null || this.formAcordo.controls['codigoTipoOrigem'].value == '') || (this.formAcordo.controls['codigoTipoRecebimento'].value == null  || this.formAcordo.controls['codigoTipoRecebimento'].value == '') ) {
        this.tipoAcordoSelecionado = false;
      } else {
        if ((this.formAcordo.controls['codigoTipoOrigem'].value == '1')) {
          if ((this.formAcordo.controls['nomeCongenere'].value == null  || this.formAcordo.controls['nomeCongenere'].value == '')) {
            this.tipoAcordoSelecionado = false;
          } else {
            this.tipoAcordoSelecionado = (this.formAcordo.value['codigoTipoRecebimento'] != "");
          }
        } else
        this.tipoAcordoSelecionado = (this.formAcordo.value['codigoTipoRecebimento'] != "");
      }

    }
  }
  public comboTipoAcordoAlterado() {

    this.carregarFormasPagamentoEntrada();
    this.carregarFormasPagamentoDemais();

    console.log(this.mostraAcordoFaturaRepasse);

    //this.tipoAcordoSelecionado = (this.formAcordo.value['codigoTipoRecebimento'] != "");
    if(this.codigoRamo == 746) {
      if(this.formAcordo.value['codigoTipoRecebimento'] == 11 ) {
        this.desabilitarPainelNegociacao[0] = true; //tipo de recebimento recebe true caso seja cobranca advocacia
      } else {
        this.desabilitarPainelNegociacao[0] = false;
      }

      if(this.formAcordo.value['codigoTipoRecebimento'] == 3) {
        this.habilitarPercentualDesconto[0] = true; // tipo de recebimento recebe true caso seja cobranca de area tecnica
      } else {
        this.habilitarPercentualDesconto[0] = false;
      }

      if(this.desabilitarPainelNegociacao[0] == true && this.desabilitarPainelNegociacao[1] == true ) {
        // se tipo de recebimento e procedencia forem true ele ira desabilitar o painel de negociacao
        this.desabilitarPainelNegociacao[2] = true;
        this.limparPainelNegociacao();
      } else {
        this.desabilitarPainelNegociacao[2] = false;
      }

      if(this.habilitarPercentualDesconto[0] == true && this.habilitarPercentualDesconto[1] == true) {
        // se tipo de recebimento e procedencia forem true ele ira desabilitar o painel de negociacao
        this.habilitarPercentualDesconto[2] = true;
        this.limparPainelNegociacao();
      } else {
        this.habilitarPercentualDesconto[2] = false;
      }
    }
  }

  public comboProcedenciaAlterado() {
    if(this.codigoRamo == 746) {
      if(this.formAcordo.value['codigoProcedencia'] == 1) {
        this.desabilitarPainelNegociacao[1] = true;  // procedencia recebe true caso seja judicial
      } else {
        this.desabilitarPainelNegociacao[1] = false;
      }

      if(this.formAcordo.value['codigoProcedencia'] == 2) {
        this.habilitarPercentualDesconto[1] = true;  // procedencia recebe true caso seja administrativo
      } else {
        this.habilitarPercentualDesconto[1] = false;
      }

      if(this.desabilitarPainelNegociacao[0] == true && this.desabilitarPainelNegociacao[1] == true) {
      // se tipo de recebimento e procedencia forem true ele ira desabilitar o painel de negociacao
        this.desabilitarPainelNegociacao[2] = true;
        this.limparPainelNegociacao();
      } else {
        this.desabilitarPainelNegociacao[2] = false;
      }

      if(this.habilitarPercentualDesconto[0] == true && this.habilitarPercentualDesconto[1] == true) {
      // se tipo de recebimento e procedencia forem true ele ira desabilitar o painel de negociacao
        this.habilitarPercentualDesconto[2] = true;
        this.limparPainelNegociacao();
      } else {
        this.habilitarPercentualDesconto[2] = false;
      }
    }
  }

  public limparPainelNegociacao() {
    if(this.habilitarPercentualDesconto[2] == true && this.desabilitarPainelNegociacao[2] == false) {
      this.formAcordo.controls['percentualHonorario'].setValue(0);
      this.formAcordo.controls['percentualCorrecaoNegociacao'].setValue(0.0);
      this.formAcordo.controls['valorDiferencaComHonorario'].setValue(null);
      this.formAcordo.controls['valorAtualizadoComDesconto'].setValue(null);

    } else if(this.habilitarPercentualDesconto[2] == false && this.desabilitarPainelNegociacao[2] == true) {
      this.formAcordo.controls['percentualHonorario'].setValue(0);
      this.formAcordo.controls['percentualCorrecaoNegociacao'].setValue(0.0);
      this.formAcordo.controls['valorDiferencaComHonorario'].setValue(null);
      this.formAcordo.controls['valorAtualizadoComDesconto'].setValue(null);
      this.formAcordo.controls['percentualDesconto'].setValue(null);
      this.formAcordo.controls['valorDiferencaDivida'].setValue(null);
    }
  }

  public combosEmissaoAcordoAlterado() {
    console.log("Algum combo de emissao de acordo foi alterado...");
    this.validarTipoProcedencia();

    if (this.appComponent.codigoRamo == 746) {
      return;
    }

    var _tipoAcordo = this.formAcordo.value['codigoTipoRecebimento'];
    var _procedencia = this.formAcordo.value['codigoProcedencia'];
    var _tipoOrigem = this.formAcordo.value['codigoTipoOrigem'];

    this.formAcordo.controls['percentualHonorario'].setValue(null);

    if (TipoAcordoEnum.RESSARCIMENTO_AUTO == _tipoAcordo) {
      if (TipoProcedenciaAcordoEnum.ADMINISTRATIVO == _procedencia) {
        if (TipoOrigemAcordoEnum.CONGENERES == _tipoOrigem) {
          if(this.desabilitarPainelNegociacao[2] == true && this.habilitarPercentualDesconto[2] == true){
              this.formAcordo.controls['percentualHonorario'].setValue(0);
          } else {
            console.log("Deve aplicar 15% de Honorarios ( Situacao 2 )");
            // Percentual de honorarios eh calculado pelo ODM
            //this.formAcordo.controls['percentualHonorario'].setValue(15);
          }
         } else if (_tipoOrigem != undefined) {
         	if(this.desabilitarPainelNegociacao[2] == true && this.habilitarPercentualDesconto[2] == true){
            	this.formAcordo.controls['percentualHonorario'].setValue(0);
          	} else {
            	console.log("Nao deve ser aplicado nenhum honorario...");
            	this.formAcordo.controls['percentualHonorario'].setValue(20);
          	}
         }
      } else if (_tipoOrigem != undefined) {
        if(this.desabilitarPainelNegociacao[2] == true && this.habilitarPercentualDesconto[2] == true){
          this.formAcordo.controls['percentualHonorario'].setValue(0);
        } else {
          console.log("Nao deve ser aplicado nenhum honorario...");
          this.formAcordo.controls['percentualHonorario'].setValue(20);
        }
      }
    }
  }

  public validarTipoProcedencia() {
    var _procedencia = this.formAcordo.value['codigoProcedencia'];
    if (TipoProcedenciaAcordoEnum.JUDICIAL == _procedencia) {
      this.formAcordo.controls['valorAtualizado'].enable();
    } else {
      this.formAcordo.controls['valorAtualizado'].disable();
    }
  }

  public calcularValorAtualizado() {
    console.log("chamando o servico de calculo de valor atualizado.... ");
    if (this.codigoRamo === 531) {
      this.calcularValorDivida(TipoCalculoDividaEnum.PREJUIZO);
    } else if (this.codigoRamo === 746) {
      this.calcularValorDivida(TipoCalculoDividaEnum.PREJUIZO_FIANCA);
    }
  }

  public calcularDiferencaValorAtualizado() {
    var valorAtualizadoDiferencaOriginal =
            this.formAcordo.controls['valorAtualizado'].value - this.formAcordo.controls['valorAtualizadoOriginal'].value;

    if (this.codigoRamo === 531 && valorAtualizadoDiferencaOriginal > 0) {
        this.formAcordo.controls['valorAtualizadoDiferencaOriginal'].setValue(valorAtualizadoDiferencaOriginal);

        this.calcularValorDivida(TipoCalculoDividaEnum.PREJUIZO);
    } else {
        this.formAcordo.controls['valorAtualizado'].setValue(this.formAcordo.controls['valorAtualizadoOriginal'].value);
    }
  }

  public calcularValorHonorarioFianca() {
    console.log("chamando o servico de calculo de valor atualizado.... ");
    this.calcularValorDivida(TipoCalculoDividaEnum.VALOR_HONORARIO_FIANCA);
  }

  public atualizarValorAcordoPeloValorSalvado() {
    this.calcularValorDivida(TipoCalculoDividaEnum.VALOR_VENDA_SALVADO);
  }

  public atualizarValorAcordoPeloPercentualDesconto() {
    console.log("chamar o servico de calculo de valores, calculando tipo de desconto.... ");
    this.calcularValorDivida(TipoCalculoDividaEnum.PERCENTUAL_DESCONTO);
  }

  public atualizarAPartirValorDesconto() {
    console.log("chamar o servico de calculo de valores, calculando o valor a partir do desconto.... ");
    this.calcularValorDivida(TipoCalculoDividaEnum.VALOR_DESCONTO);
  }

  public atualizarDescontoComValorAcordo() {
    var valor = this.formAcordo.controls['valorAcordo'].value - this.formAcordo.controls['valorAtualizado'].value;
    this.formAcordo.controls['valorDiferencaDivida'].setValue(valor * -1);

    this.calcularValorDivida(TipoCalculoDividaEnum.VALOR_DESCONTO);
  }
  public atualizarDescontoComValorAcordoAuto() {
    if (this.formAcordo.controls['valorAcordo'].value < this.formAcordo.controls['valorAtualizado'].value ) {
      var valor = this.formAcordo.controls['valorAcordo'].value - this.formAcordo.controls['valorAtualizado'].value;
      var resultado = ((((valor / this.formAcordo.controls['valorAtualizado'].value) * 100) * -1));

      if (resultado == Infinity) {
        this.formAcordo.controls['percentualDesconto'].setValue(0);
      } else if (resultado == NaN) {
        this.formAcordo.controls['percentualDesconto'].setValue(0);
      } else
      {
      this.formAcordo.controls['percentualDesconto'].setValue(resultado);
      }
    } else {
      this.formAcordo.controls['percentualDesconto'].setValue(0);
    }
    this.atualizarValorAcordoPeloPercentualDesconto();
    this.getHonorarioFlutuante();
    this.inicializarGridParcelas();
  }

  public maxPercentualHonoraioFianca() {
    var percentualHonorario = this.getValorPercentual(this.formAcordo.value['percentualHonorario']);
    if(this.desabilitarPainelNegociacao[2] == true){
      this.formAcordo.controls['percentualHonorario'].setValue(0);
    }
    if (this.appComponent.codigoRamo == 746 && percentualHonorario > 15) {
        // Percentual de honorarios deve ser calculado pelo ODM
        //this.formAcordo.controls['percentualHonorario'].setValue(15);
    }
    this.calcularValorAtualizado();
  }

  public calcularValorDespesasCustas(){
    console.log("chamar o servico de calculo de de despesas custas");
    this.calcularValorDivida(TipoCalculoDividaEnum.VALOR_DESPESAS_CUSTAS);
  }

  public calcularValorDescontoDespesasCustas() {
    console.log("chamar o servico de calculo de Desconto Despesas / Custas");
    this.calcularValorDivida(TipoCalculoDividaEnum.VALOR_DESCONTO_DESPESAS_CUSTAS);
  }

  public selecionarPagador(indexPagador) {
    this.formAcordo.controls['flagPagador'].setValue(null);
    this.formAcordo.controls['flagPagador'].setValue(indexPagador);
    console.log("Pagador selecionado no index: " + this.formAcordo.value['flagPagador']);
    this.FlagTerceiro = true;

    if (this.devedores && this.devedores.length > 1) {
      for (var i = 0; i < this.devedores.length; i++) {
        this.devedores[i].flagPagador = null;
        this.FlagTerceiro = false;
      }
    }

    if (this.devedores && this.devedores.length > 0) {
      for (var i = 0; i < this.devedores.length; i++) {
        if (this.formAcordo.value['flagPagador'] === i) {
          this.devedores[i].flagPagador = true;
          this.FlagTerceiro = true;
        }
      }
    }
  }

  public openEditarDevedor(indexDeveddor) {
    this.edicaoDevedor = true;
    this.indexEdicaoDevedor = indexDeveddor;

    this.limparDadosDevedor();

    console.log("Pagador selecionado no index: " + this.formAcordo.value['flagPagador']);

    if (this.devedores && this.devedores.length > 0) {
      //-- Dados basicos
      this.formAcordo.controls['nomeNovoDevedor'].setValue(this.devedores[indexDeveddor].nome);
      this.formAcordo.controls['scoreDevedor'].setValue(this.devedores[indexDeveddor].score);
      this.formAcordo.controls['probInadimDevedor'].setValue(this.devedores[indexDeveddor].probInadimplencia);
      this.formAcordo.controls['negativadoNovoDevedor'].setValue(this.devedores[indexDeveddor].flagNegativado);
      this.formAcordo.controls['congenereNovoDevedor'].setValue(this.devedores[indexDeveddor].flagCongenere);
      this.formAcordo.controls['flagPagador'].setValue(this.devedores[indexDeveddor].flagPagador);

      if (this.devedores[indexDeveddor].tipoPessoa === TipoPessoaEnum.FISICA) {
        this.formAcordo.controls['tipoPessoa'].setValue('0');
        this.formAcordo.controls['cpfNovoDevedor'].setValue(this.devedores[indexDeveddor].cpf);
      } else {
        this.formAcordo.controls['tipoPessoa'].setValue('1');
        this.formAcordo.controls['cnpjNovoDevedor'].setValue(this.devedores[indexDeveddor].cnpj);
      }

      //- Emails
      const emailControl = <FormArray>this.formAcordo.controls['emailsDevedor'];
      for( let i = 0; i < this.devedores[indexDeveddor].emails.length; i++) {
        let emailNovoDevedor = this.devedores[indexDeveddor].emails[i].endereco;
        if(emailNovoDevedor != undefined){
          emailControl.push(this.formBuilder.group({emailNovoDevedor}));
        }
      }

      //-- Telefones
      const telefoneControl = <FormArray>this.formAcordo.controls['telefonesDevedor'];

      if(this.devedores[indexDeveddor].telefones != undefined){

        let dddTelefone;
        let numeroTelefone;
        let telefoneCompleto;
        let valorTipoLinhaTelefonica;

        for( let i = 0; i < this.devedores[indexDeveddor].telefones.length; i++) {

          dddTelefone = this.devedores[indexDeveddor].telefones[i].codigoDDDTelefone;
          numeroTelefone =  this.devedores[indexDeveddor].telefones[i].numeroTelefone;
          telefoneCompleto = String(dddTelefone) + String(numeroTelefone);
          valorTipoLinhaTelefonica = 0;

          if(this.devedores[indexDeveddor].telefones[i].tipoLinhaTelefonica  == TipoLinhaTelefonicaEnum.FIXO || ( this.devedores[indexDeveddor].telefones[i].tipoLinhaTelefonica  == undefined  && telefoneCompleto.length == 10)) {
            valorTipoLinhaTelefonica = 0;
            telefoneCompleto = telefoneCompleto.replace(/(\d{2})(\d{4})(\d{4})/g,"(\$1) \$2-\$3");
          } else if (this.devedores[indexDeveddor].telefones[i].tipoLinhaTelefonica === TipoLinhaTelefonicaEnum.CELULAR || ( this.devedores[indexDeveddor].telefones[i].tipoLinhaTelefonica  == undefined && telefoneCompleto.length == 11)) {
            valorTipoLinhaTelefonica = 1;
            telefoneCompleto = telefoneCompleto.replace(/(\d{2})(\d{5})(\d{4})/g,"(\$1) \$2-\$3");
          }

          telefoneControl.push(this.formBuilder.group({tipoTelefone : valorTipoLinhaTelefonica, telefone: telefoneCompleto}));

        }
      }

      //-- Endereco
      this.formAcordo.controls['codigoEndereco'].setValue(this.devedores[indexDeveddor].endereco.codigoEndereco);
      if(this.devedores[indexDeveddor].endereco.cep != undefined && this.devedores[indexDeveddor].endereco.cep.length == 8){
        this.formAcordo.controls['cepNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.cep.replace(/(\d{5})(\d{3})/g,"\$1-\$2"));
        this.pesquisarCEP();
      }else{
        this.formAcordo.controls['cepNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.cep);
      }
      this.formAcordo.controls['tipoEnderecoNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.tipoEndereco);
      this.formAcordo.controls['enderecoNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.logradouro);
      this.formAcordo.controls['numeroNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.numero);
      this.formAcordo.controls['complementoNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.complemento);
      this.formAcordo.controls['bairroNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.bairro);
      this.formAcordo.controls['cidadeNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.cidade);
      this.formAcordo.controls['estadoNovoDevedor'].setValue(this.devedores[indexDeveddor].endereco.estado);

      //-- Categoria
      this.formAcordo.controls['codigoCategoriaDevedor'].setValue(this.devedores[indexDeveddor].codigoCategoriaDevedor);
    }
  }

  public autoCompleteBuscaCadastroCongenere() {
     return (keyword: any): Observable<any> => {
       const listaFiltrada = this.cadastroCongeneres.filter(function(congenere) {
          return congenere.descricao.toUpperCase().indexOf(keyword.toUpperCase()) !== -1;
       });

       const listaNomes =[];
       listaFiltrada.forEach(function(congenere){
          listaNomes.push(congenere.descricao);
       });

       return of(listaNomes);
     };
  }

  public autoCompleteBuscaCadastroCongenereSelected($event) {
    this.selected = $event;

    const congenereFiltrada = this.cadastroCongeneres.filter(function(congenere) {
       return congenere.descricao.toUpperCase().indexOf($event.toUpperCase()) !== -1;
    });

    this.devedores.forEach(function(devedor){
       devedor.congenere = congenereFiltrada[0];
    });
  }

  public salvarProposta(componenteModalGravando, componenteModalJustificativa, componenteModalGeraAcordo): void {
    this.mensagemErroProposta = '';

    if (!this.formAcordo.value['textoJustificativaCriacao'] ||
        !this.formAcordo.value['textoJustificativaCriacao'].trim()) {
      this.mensagemErroProposta = 'Informe a justificativa para continuar.';
      this.appComponent.createAlert(this.mensagemErroProposta, 'alert');
      return;
    }

    if (this.formAcordo.get('valorVendaSalvado').value > this.formAcordo.get('valorAtualDivida').value) {
      this.mensagemErroProposta = 'O valor de venda/estimativa de salvados deve ser inferior ao valor do prejuízo.';
      this.appComponent.createAlert(this.mensagemErroProposta, 'alert');
      return;
    }

    this._submitted = true;
    const formularioComErro = this.validarFormulario();
    const formularioInvalido = this.formAcordo.invalid && this.verificarValidacoesNaoCpfCnpj();
    if (formularioComErro || formularioInvalido) {
      this.mensagemErroProposta = this.obterMensagemErroProposta();
      this.appComponent.createAlert(this.mensagemErroProposta, 'alert');
      return;
    }

    this.mensagemErroProposta = '';
    componenteModalJustificativa.close();
    setTimeout(() => {
      console.log("Efetuando a gravacao do Acordo..."+ new Date().toDateString());
      this.salvarPropostaImpl(componenteModalGravando, componenteModalGeraAcordo);
    }, 1500);

    componenteModalGravando.open("save");
  }

  private obterMensagemErroProposta(): string {
    if (this.formAcordo.get('qtdParcelas').invalid) {
      return 'Não foi possível validar as condições de parcelamento. Revise a forma de pagamento selecionada e tente novamente.';
    }
    return 'Não foi possível salvar a proposta. Confira os campos obrigatórios destacados, corrija os dados e tente novamente.';
  }

  private salvarPropostaImpl(componenteModalGravando, componenteModalGeraAcordo): void {

    this._submitted = true;

    var isFormuarioInvalido = this.validarFormulario();

    Object.keys(this.formAcordo.controls).forEach(key => {

      const controlErrors: ValidationErrors = this.formAcordo.get(key).errors;
      if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            });
          }
        });

    if ((this.formAcordo.invalid && this.verificarValidacoesNaoCpfCnpj()) || isFormuarioInvalido) {
      componenteModalGravando.close();
      this.mensagemErroProposta = this.obterMensagemErroProposta();
      this.appComponent.createAlert(this.mensagemErroProposta, 'alert');
      return;
    }

    this.inicializarDadosAcordo();
    this.acordo.codigoMarca = this.formAcordo.value['codigoMarca'];
    this.acordo.processoRessarcimento.codigoRamoSinistro = this.formAcordo.value['codigoRamoSinistro'];
    this.acordo.processoRessarcimento.anoSinistro = this.formAcordo.value['anoSinistro'];
    this.acordo.processoRessarcimento.numeroSinistro = this.formAcordo.value['numeroSinistro'];
    this.acordo.processoRessarcimento.sequenciaItemSinistro = this.formAcordo.value['sequenciaItemSinistro'];
    this.acordo.processoRessarcimento.codigoSucursal = this.formAcordo.value['codigoSucursal'];
    //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
    this.acordo.processoRessarcimento.codigoSinistroItau = this.formAcordo.value['codigoSinistroItau'];
    //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
    this.acordo.codigoEscritorio = this.formAcordo.value['codigoEscritorio'];
    this.acordo.nomeEscritorio = this.formAcordo.value['escritorio'];
    this.acordo.procedencia.codigoProcedencia = this.formAcordo.value['codigoProcedencia'];
    this.acordo.tipoRecebimento.codigoTipoRecebimento = this.formAcordo.value['codigoTipoRecebimento'];
    this.acordo.tipoOrigemAcordo.codigoTipoOrigem = this.formAcordo.value['codigoTipoOrigem'];
    this.acordo.valorAtualDivida = Number(this.formAcordo.value['valorAtualDivida']);
    this.acordo.valorAcordo = Number(this.formAcordo.value['valorAcordo']);
    this.acordo.valorRecuperado = Number(this.formAcordo.value['valorRecuperado']);
    this.acordo.valorDiferencaDivida = Number(this.formAcordo.value['valorDiferencaDivida']);
    this.acordo.valorDesconto = Number(this.formAcordo.value['valorDesconto']);
    this.acordo.percentualDesconto = this.getPercentualDesconto();
    this.acordo.percentualHonorarioFlutuante = Number(this.getValorPercentual(this.formAcordo.value['percentualHonorarioFlutuante']));
    this.acordo.dataDivida = moment(this.formAcordo.value['dataDivida'], "YYYY-MM-DD").format("YYYY-MM-DD");
    this.acordo.percentualHonorario = Number(this.getValorPercentual(this.formAcordo.value['percentualHonorario']));
    this.acordo.flagCobradaCorrecaoMonetaria = this.getPercentualCorrecaoNegociacao() > 0 ? "S" : "N";
    this.acordo.valorSalvados = this.formAcordo.value['valorVendaSalvado'];
    this.acordo.despesasCustas = this.formAcordo.value['despesasCustas'];
    this.acordo.descontoDespesasCustas = this.formAcordo.value['descontoDespesasCustas'];

    this.acordo.valorLimiteMaximoIndenizacao = this.formAcordo.value['lmi'];

    this.acordo.banco = this.formAcordo.value['banco'];
    this.acordo.agencia = this.formAcordo.value['agencia'];
    this.acordo.conta = this.formAcordo.value['conta'];

    if( this.formAcordo.value['dinamica'] != null && this.formAcordo.value['dinamica'] != "" ) {
        this.acordo.dinamica = this.formAcordo.value['dinamica'];
    } else if( this.dinamicaAcordo instanceof Array ) {
        this.acordo.dinamica = this.dinamicaAcordo[0].idDinamica;
    }
    this.acordo.textoJustificativaCriacao = this.formAcordo.value['textoJustificativaCriacao'];
    //TODO setar campos na tela
    this.acordo.percentualTaxaJuro = 0;
    if (this.formAcordo.value['checkboxComJuros']) {
      //if (this.appComponent.codigoRamo == 746) {
        this.acordo.percentualTaxaJuroParcela = Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'].replace(',', '.')));
      //} else if (this.appComponent.codigoRamo == 531) {
      //  this.acordo.percentualTaxaJuroParcela = 1;
     // }

    } else {
        this.acordo.percentualTaxaJuroParcela = 0;
    }
    this.acordo.flagPropostaAcordo = AppConstantes.FLAG_SIM;

    if(this.formAcordo.value['flagEnvioBoletoMensal']){
        this.acordo.flagEnvioBoletoMensal = AppConstantes.FLAG_SIM;
    } else {
        this.acordo.flagEnvioBoletoMensal = AppConstantes.FLAG_NAO;
    }

    //TODO setar campos depois corretamente
    this.acordo.valorDespesaProcesso = 0;
    this.acordo.valorRessarcimentoRealizado = 0;
    this.acordo.valorProvisionamento = 0;

    this.acordo.flagAcordoEscalonado = AppConstantes.FLAG_NAO;
    if (this.formAcordo.value['checkboxgAcordoEscalonado']) {
      this.acordo.flagAcordoEscalonado = AppConstantes.FLAG_SIM;
    }

    let cobrarJuros = AppConstantes.FLAG_NAO;
    if (this.formAcordo.value['checkboxComJuros']) {
      cobrarJuros = AppConstantes.FLAG_SIM;
    }

    this.parcelas = [];

    if (this.formAcordo.value['radioEntrada'] && this.formAcordo.value['radioEntrada'] === '1' ||
          this.formAcordo.value['radioEntrada'] && this.formAcordo.value['radioEntrada'] === '3') {
      const parcela: Parcela = {};
      parcela.numeroParcela = Number(1);
      parcela.valorParcela = Number(this.formAcordo.value['valorEntrada']);
      parcela.valorParcelaSemJuros = parcela.valorParcela;
      parcela.valorParcelaJuros = Number(0);
      parcela.valorHonorarioPago = Number(this.formAcordo.controls['valorHonorarioEntrada'].value);
      parcela.dataVencimentoParcela = moment(this.formAcordo.value['dataVencimentoEntrada'], "DD/MM/YYYY").format("YYYY-MM-DD");
      parcela.numeroContratoFinanceiro = 0;
      parcela.flagCobrancaJuroAtraso = cobrarJuros;
      parcela.tipoParcela = {};
      parcela.tipoParcela.codigoTipoParcela = TipoParcelaAcordoEnum.ENTRADA; //ENTRADA
      parcela.tipoSituacaoParcelaAcordo = {};
      parcela.tipoSituacaoParcelaAcordo.codigoTipoSituacaoParcelaAcordo = SituacaoParcelaEnum.A_VENCER; //A VENCER
      parcela.formaPagamento = {};
      parcela.formaPagamento.codigoFormaPagamento = Number(this.formAcordo.value['codigoFormaPagamentoEntrada']);

      this.parcelas.push(parcela);
    }

    const parcelasFormArray = this.formAcordo.controls.parcelasForm as FormArray;
    Object.keys(parcelasFormArray.controls).forEach(key => {

      const parcela: Parcela = {};
      const control = parcelasFormArray.get(key);

      if (!control['numeroParcela']) {
        control.markAsTouched({ onlySelf: true });
      }
      parcela.numeroParcela = Number(control.value['numeroParcela']);

      if (!control['valorParcela']) {
        control.markAsTouched({ onlySelf: true });
      }
      parcela.valorParcela = Number(control.value['valorParcela']);
      parcela.valorParcelaSemJuros = Number(control.value['valorParcelaSemJuros']);
      parcela.valorParcelaJuros = Number(control.value['valorParcelaJuros']);

      if (!control['valorHonorarioPago']) {
        control.markAsTouched({ onlySelf: true });
      }
      parcela.valorHonorarioPago = Number(control.value['valorHonorarioPago']);

      if (!control['dataVencimentoParcela']) {
        control.markAsTouched({ onlySelf: true });
      }
      parcela.dataVencimentoParcela = moment(control.value['dataVencimentoParcela'], "DD/MM/YYYY").format("YYYY-MM-DD");

      parcela.numeroContratoFinanceiro = 0;
      parcela.flagCobrancaJuroAtraso = cobrarJuros;
      parcela.tipoParcela = {};
      parcela.tipoParcela.codigoTipoParcela = TipoParcelaAcordoEnum.DEMAIS_PARCELAS; //DEMAIS PARCELAS
      parcela.tipoSituacaoParcelaAcordo = {};
      parcela.tipoSituacaoParcelaAcordo.codigoTipoSituacaoParcelaAcordo = SituacaoParcelaEnum.A_VENCER; //A VENCER
      parcela.formaPagamento = {};
      parcela.formaPagamento.codigoFormaPagamento = Number(this.formAcordo.value['codigoFormaPagamento']);

      this.parcelas.push(parcela);

    });

    this.acordo.parcelaLista = {};
    this.acordo.parcelaLista.parcelas = this.parcelas;

    //-- Devedores
    this.acordo.devedores = this.devedores;

    this.acordo.devedores.forEach(dev => {
      if (dev.cpf == null || dev.cpf == undefined){
        dev.cpf == '';
      }
      if (dev.cnpj == null || dev.cnpj == undefined || dev.cnpj.length == 0){
        dev.cnpj == '';
      }

      if (dev.telefones == undefined ||dev.telefones.length == 0) {
        let tel = <Telefone>{};
        tel.codigoDDDTelefone = 0;
        tel.codigoTelefone =0;
        tel.codigoDDITelefone=0;
        tel.numeroTelefone =0;
        tel.numeroRamalTelefone=undefined;
        tel.tipoLinhaTelefonica= TipoLinhaTelefonicaEnum.FIXO;
        let tipoFinalidadeTelefone = <TipoFinalidadeTelefone>{};
        tel.tipoFinalidadeTelefone=  tipoFinalidadeTelefone;
        dev.telefones = new Array<Telefone>(tel) ;

      }

      if (dev.emails == undefined || dev.emails.length == 0) {
          let mail = <EmailType>{};
         mail.endereco = '';
         mail.tipo = '';
         dev.emails = new Array<EmailType>(mail) ;
      } else {
          dev.emails.forEach (e_mail =>{
            if (e_mail.endereco == undefined || e_mail.endereco == null)
              e_mail.endereco = '';
          });
      };

      if (dev.endereco.codigoEndereco == undefined || dev.endereco.codigoEndereco == null)
        dev.endereco.codigoEndereco = 1019837;
      if (dev.endereco.tipoEndereco == undefined || dev.endereco.tipoEndereco == null)
        dev.endereco.tipoEndereco = 'Rua';
        if (dev.endereco.cep == undefined || dev.endereco.cep == null)
        dev.endereco.cep = '071150000';
        if (dev.endereco.logradouro == undefined || dev.endereco.logradouro == null)
        dev.endereco.logradouro = '';
        if (dev.endereco.numero == undefined || dev.endereco.numero == null)
        dev.endereco.numero = '0';
        if (dev.endereco.complemento == undefined || dev.endereco.complemento == null)
        dev.endereco.complemento = '';

        if (dev.endereco.bairro == undefined || dev.endereco.bairro == null)
        dev.endereco.bairro = '';
        if (dev.endereco.cidade == undefined || dev.endereco.cidade == null)
        dev.endereco.cidade = '';
        if (dev.endereco.estado == undefined || dev.endereco.estado == null)
        dev.endereco.estado = '';

        if (dev.flagPagador == undefined || dev.flagPagador == null)
        dev.flagPagador = false;

        if (dev.strCpfGrid == undefined || dev.strCpfGrid == null)
        dev.strCpfGrid = '';
        if (dev.strTelefoneGrid == undefined || dev.strTelefoneGrid == null)
        dev.strTelefoneGrid = '';

    })
    console.log ('OBJ DEVEDOR '+JSON.stringify(this.acordo.devedores));

    if( this.codigoRamo == 531 ) {

      this.acordo.devedores = this.acordo.devedores.filter((devedor) => { return devedor.flagPagador == true;  });
      console.log ('OBJ DEVEDOR AUTO SOMENTE PAGADOR '+JSON.stringify(this.acordo.devedores));
    }
    console.log('Salvando proposta...');

    this.mostrarBotaoProposta = false;

    this.propostaService.salvarProposta(this.acordo)
      .subscribe((data: any) => {

        componenteModalGravando.close();


        if(data.mensagem != undefined && data.mensagem.status_code != undefined && data.mensagem.status_code === '409'){
          console.log('Erro ao criar a proposta!' + data.mensagem.message);
          this.appComponent.createAlert(data.mensagem.message, 'error');
          this.mostrarBotaoProposta = true;
          return;
        }

        this.appComponent.createAlert('Proposta de número '+ data.codigoAcordoSistema + ' criada com sucesso!', 'success');

        this.acordo.codigoAcordo = data.codigo;
        this.acordo.codigoAcordoSistema = data.codigoAcordoSistema;

        this.acordo.temAlcada = data.temAlcada;

        if( !this.acordo.temAlcada ) {
            this.modalConcluidoProposta.open(null);
        } else {
          if (this.acordo.codigoAcordo != null) {
            componenteModalGeraAcordo.open('Proposta de número '+ data.codigoAcordoSistema + ' criada com sucesso!');
          }
        }

      }, error => {
        componenteModalGravando.close();
        console.log('Erro ao criar a proposta!' + error);
        if(error.error != undefined && error.error.mensagem != undefined && error.error.mensagem.status_code === '409'){
          this.appComponent.createAlert(error.error.mensagem.message, 'error');
        } else  {
          this.appComponent.createAlert('Ocorreu um erro ao gravar a Proposta. Tente novamente mais tarde.', 'error');
        }
        this.mostrarBotaoProposta = true;
      });

  }

  public tipoPagamento(){
    if(this.formAcordo.value['radioEntrada'] != 1){
      this.radioParcela = true;
    }else{
      this.radioParcela = false;
    }
    console.log(this.radioParcela);
    //console.log(this.formAcordo.value['radioEntrada'].getValue);
    console.log(this.formAcordo.value['radioEntrada']);
  }

  public changeVerificarAndLimparParcelas(event) {
    this.inicializarGridParcelas();
    this.limparTabelaParcelas();

    this.formAcordo.controls['checkboxComJuros'].setValue(null);
    this.formAcordo.controls['percentualJurosParcela'].setValue(null);
    this.formAcordo.controls['checkboxgAcordoEscalonado'].setValue(null);
    this.formAcordo.controls['dataPrimeiroVencimento'].setValue(null);
    this.formAcordo.controls['dataVencimentoEntrada'].setValue(null);
    this.formAcordo.controls['valorHonorarioEntrada'].setValue(null);
    this.formAcordo.controls['codigoFormaPagamentoEntrada'].setValue(null);

    // verifica se é o caso de uma parcela única
    if(this.formAcordo.value['radioEntrada'] === '3') {
      this.formAcordo.controls['qtdParcelas'].setValue(1);
      var valorParcelaUnica = this.formAcordo.value['valorAcordo'];

      this.formAcordo.controls['valorEntrada'].setValue(valorParcelaUnica);
      this.formAcordo.controls['valorHonorarioEntrada'].setValue(this.getValorHonorarioConsiderar(valorParcelaUnica));
    } else {
      this.formAcordo.controls['valorEntrada'].setValue(null);
      this.formAcordo.controls['valorHonorarioEntrada'].setValue(null);
      this.formAcordo.controls['qtdParcelas'].setValue(null);
      this.formAcordo.controls['dataVencimentoEntrada'].setValue(null);

    }
  }

  public carregarDataPrimeiroVencimento(evt) {
    if (evt) {
      var data = evt;
      this.formAcordo.controls['dataPrimeiroVencimento'].setValue(data);
    }
    this.carregarParcelas();
  }

  public carregarDataVencimentoEntrada(evt) {
    if (evt) {
      var data = evt;
      this.formAcordo.controls['dataVencimentoEntrada'].setValue(data);
    }
    this.carregarParcelas();
  }

  private getPercentualDesconto(): number {
    var valorPercentualDigitado = this.formAcordo.controls['percentualDesconto'].value;

    if(!valorPercentualDigitado || valorPercentualDigitado == null || valorPercentualDigitado == ''){
        return Number(0.00);
    }

    valorPercentualDigitado = Number(valorPercentualDigitado.toString().replace('%', '').replace(',', '.').trim());

    if(valorPercentualDigitado > 100) {
        this.appComponent.createAlert("O valor do Percentual de Desconto não pode ser maior que 100%!", "error");
        this.zerarValoresDesconto();
        return Number(0.00);
    }

    return valorPercentualDigitado;
  }

  private getValorPercentual(valorPercentual): number {
    if (valorPercentual && valorPercentual !== null && valorPercentual !== '') {
        return Number(valorPercentual.toString().replace('%', '').trim());
    } else {
        return Number(0);
    }
  }

  private getPercentualCorrecaoNegociacao(): number {
    var percent = this.formAcordo.value['percentualCorrecaoNegociacao'];
    if(percent != null && percent != ''){
        percent = Number(percent.toString().replace(' % a.m', '').replace(',', '.').trim());

        if(percent > 1){
            percent = Number(1.00);
            this.formAcordo.controls['percentualCorrecaoNegociacao'].setValue('1,0');
            this.appComponent.createAlert("O Percentual de Correção não pode ser maior que 1,0 % a.m!", "error");
        }
    } else {
        this.formAcordo.controls['percentualCorrecaoNegociacao'].setValue('1,0');
        percent = Number(1.00);
    }

    return percent;
  }

  private atualizarValoresParcelas(parcela: any): void {
    console.log('Inicio método atualizarValoresParcelas');
    console.log('parcela: ' + JSON.stringify(parcela));

    if (parcela.valorParcela === parcela.valorParcelaOriginal) {
      return;
    }

    /**
    if (parcela.editada === true) {
      this.setMensagemAlert('', 'Parcela já foi editada.');
      return;
    }
     */

    const parcelasFormArray = this.formAcordo.controls.parcelasForm as FormArray;

    let valorAcordo = Number(this.formAcordo.value['valorAcordo']);
    let numeroParcela = parcela.numeroParcela;
    let valorParcela = parcela.valorParcela;
    let valorParcelaSemJuros = this.getValorParcelaSemJuros(valorParcela);
    let qtdParcelas = parcelasFormArray.length;

    if (this.isPossuiValorEntrada()) {
      let valorEntrada = Number(this.formAcordo.value['valorEntrada']);
      valorAcordo = valorAcordo - valorEntrada;
    }

    let qtdParcelasRestante = Number(0);
    let qtdParcelasEditadas = Number(0);
    let valorParcelaRestante = Number(0);
    let msgAlertEditarApenasUmaParcelaDisponivel = '';

    Object.keys(parcelasFormArray.controls).forEach(key => {

      const control = parcelasFormArray.get(key);

      if (Number(control.value['numeroParcela']) > 0) {

        if (!control['editada']) {
          control.markAsTouched({ onlySelf: true });
        }
        if (!control['valorParcela']) {
          control.markAsTouched({ onlySelf: true });
        }

        if (!this.formAcordo.value['checkboxgAcordoEscalonado']) {
          control['controls'].valorParcela.setValue(parcela.valorParcelaOriginal);
          msgAlertEditarApenasUmaParcelaDisponivel = 'Não foi possivel editar a parcela. O Acordo não é escalonado.';
          return;
        } else if (qtdParcelas <= 1) {
          control['controls'].valorParcela.setValue(parcela.valorParcelaOriginal);
          msgAlertEditarApenasUmaParcelaDisponivel = 'Não foi possivel editar apenas uma parcela.';
          return;
        } else if (control.value['editada'] === true) {
          qtdParcelasEditadas++;
          valorParcelaRestante = valorParcelaRestante + Number(control.value['valorParcelaSemJuros']);

          console.log('valorParcelaSemJuros' + Number(control.value['valorParcelaSemJuros']));
        } else if (Number(control.value['numeroParcela']) === numeroParcela) {

          if(parcela.editada) {
            valorParcelaRestante = valorParcelaRestante + Number(valorParcela);
          }

          if (qtdParcelasEditadas == qtdParcelas - 1) {
            control['controls'].valorParcela.setValue(Number(control.value['valorParcelaOriginal']));
            msgAlertEditarApenasUmaParcelaDisponivel = 'Não foi editar apenas uma parcela disponível.';
            return;
          }

          qtdParcelasEditadas++;

          control['controls'].editada.setValue(true);
          valorParcelaRestante = valorParcelaRestante + valorParcelaSemJuros;
          console.log('Vlrparcelarestante(2) '+valorParcelaRestante);
          console.log('valorParcelaSemJuros(2) '+valorParcelaSemJuros);
        } else {
          qtdParcelasRestante++;
        }

      }

    });
    console.log('Vlrparcelarestante(1) '+valorParcelaRestante);
    console.log('qtdParcelasEditadas '+qtdParcelasEditadas);
    if (msgAlertEditarApenasUmaParcelaDisponivel && msgAlertEditarApenasUmaParcelaDisponivel.length > 0) {
      this.setMensagemAlert('', msgAlertEditarApenasUmaParcelaDisponivel);
      return;
    }

    console.log('ANTES valorAcordo '+valorAcordo);
    console.log('ANTES valorParcelaRestante '+valorParcelaRestante);

    console.log('ANTES qtdParcelasRestante '+qtdParcelasRestante);

    valorParcelaRestante = Number(((valorAcordo - valorParcelaRestante) / qtdParcelasRestante).toFixed(2));
    console.log('valorParcelaRestante '+valorParcelaRestante);

    if (valorParcelaRestante < AppConstantes.VALOR_MINIMO_PARCELA) {
      this.setMensagemAlert(null, 'Valor da(s) parcela(s) deve ser maior ou igual é ' + AppConstantes.VALOR_MINIMO_PARCELA);
      this.carregarParcelas();
      return;
    }

    Object.keys(parcelasFormArray.controls).forEach(key => {

      const control = parcelasFormArray.get(key);

      if (Number(control.value['numeroParcela']) > 0) {

        if (!control['valorParcela']) {
          control.markAsTouched({ onlySelf: true });
        }
        if (!control['valorParcelaOriginal']) {
          control.markAsTouched({ onlySelf: true });
        }
        if (!control['valorHonorarioPago']) {
          control.markAsTouched({ onlySelf: true });
        }

        if (Number(control.value['numeroParcela']) === numeroParcela) {

          control['controls'].valorParcela.setValue(valorParcela);
          control['controls'].valorParcelaOriginal.setValue(valorParcelaSemJuros);
          control['controls'].valorParcelaSemJuros.setValue(valorParcelaSemJuros);
          control['controls'].valorParcelaJuros.setValue(this.getValorJurosParcelaAjustada(valorParcelaSemJuros,valorParcela));
          control['controls'].valorHonorarioPago.setValue(this.getValorHonorarioConsiderar(valorParcelaSemJuros));
        } else if (control.value['editada'] === false) {
          let par = this.getValorParcelaComJuros(valorParcelaRestante, valorAcordo);

          control['controls'].valorParcela.setValue(par);
          control['controls'].valorParcelaSemJuros.setValue(valorParcelaRestante);
          control['controls'].valorParcelaJuros.setValue(this.getValorJuros(valorParcelaRestante));
          control['controls'].valorParcelaOriginal.setValue(par);
          control['controls'].valorHonorarioPago.setValue(this.getValorHonorarioConsiderar(valorParcelaRestante));
        }

      }

    });

    this.ajustarUltimaParcelaPorContaArredondamentoCentavos();
  }

  private getValorAcordoComJuros(valorAcordo: number, qtdparcelas: number): number {
    let valorAcordoComJuros = Number((valorAcordo).toFixed(2));

    if (this.formAcordo.value['checkboxComJuros']) {
      //var valorJuros = Number((valorAcordoComJuros * 1 / 100).toFixed(2));
      //var valorJuros = Number((valorAcordoComJuros * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'])) / 100).toFixed(2));
      var valorJuros = Number(((valorAcordoComJuros * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'].replace(',', '.'))) / 100) * qtdparcelas).toFixed(2) );
      console.log('getValorAcordoComJuros - valorAcordoComJuros'+valorAcordoComJuros);
      console.log('getValorAcordoComJuros - valorJuros'+valorAcordoComJuros);
      valorAcordoComJuros = valorAcordoComJuros + valorJuros;
    }
    return valorAcordoComJuros;
  }

  private getValorParcelaComJuros(valorParcela: number, valorAcordo:number = 0): number { // Vlr Acordo sem a entrada
    let valorParcelaComJuros = valorParcela;
    // valor parcela com juros
    if (this.formAcordo.value['checkboxComJuros']) {

      //if (this.codigoRamo === 746) {
       // valorParcelaComJuros = valorParcelaComJuros + (valorParcelaComJuros * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'])) / 100);
       //valorParcelaComJuros = valorParcelaComJuros + (Number(this.getValorPercentual(this.formAcordo.value['valorAcordo'])) * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'])) / 100);
       valorParcelaComJuros = valorParcelaComJuros + (valorAcordo * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'].replace(',', '.'))) / 100);
       console.log('getValorParcelaComJuros '+ valorParcelaComJuros);
       //} else if (this.codigoRamo === 531) {
      //  valorParcelaComJuros = valorParcelaComJuros + (valorParcelaComJuros * 1 / 100);
     // }
    }
    return Number(valorParcelaComJuros.toFixed(2));
  }

  private getValorParcelaSemJuros(valorParcela: number): number {
    let valorParcelaSemJuros = valorParcela;
    // valor parcela sem juros
    if (this.formAcordo.value['checkboxComJuros']) {
      valorParcelaSemJuros = (valorParcelaSemJuros * 100) / 101;
    }
    return Number(valorParcelaSemJuros.toFixed(2));
  }

  private getValorJurosParcelaAjustada(valorParcelaSemJuros: number, valorParcela: number): number{
    let valorJuros = 0;
    if (this.formAcordo.value['checkboxComJuros']) {
      valorJuros = Number((valorParcela-valorParcelaSemJuros).toFixed(2));
    }
    return valorJuros;
  }

  private getValorJuros(valor: number, valorAcordo: number =0): number { //valor do acordo - valor da entrada
    let valorJuros = 0;
    if (this.formAcordo.value['checkboxComJuros']) {

      //if (this.codigoRamo === 746) {
        //valorJuros = Number((valor * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'])) / 100).toFixed(2));
        //valorJuros = Number((Number(this.getValorPercentual(this.formAcordo.value['valorAcordo'])) * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'])) / 100).toFixed(2));

        valorJuros = Number((Number(this.getValorPercentual(valorAcordo)) * Number(this.getValorPercentual(this.formAcordo.value['percentualJurosParcela'].replace(',', '.'))) / 100).toFixed(2));
      console.log('getValorJuros');
        //} else if (this.codigoRamo === 531) {
      //  valorJuros = Number((valor * 1 / 100).toFixed(2));
     // }
    }
    return valorJuros;
  }

  private isPossuiValorEntrada(): boolean {
    return this.formAcordo.value['radioEntrada'] === '1' || this.formAcordo.value['radioEntrada'] === '3';
  }

  private limparTabelaParcelas(): void {
    const parcelasFormArray = this.formAcordo.controls.parcelasForm as FormArray;
    parcelasFormArray.controls = [];
  }

  private inicializarGridParcelas(): void {

    setTimeout(() => {
      console.log('RADIOENTRADA '+this.formAcordo.value['radioEntrada']);
        this.verificarCamposHonorarios();
      // verifica se é o caso de uma parcela única
      if(this.formAcordo.value['radioEntrada'] === '3') {
        this.formAcordo.controls['qtdParcelas'].setValue(1);
        var valorParcelaUnica = this.formAcordo.value['valorAcordo'];

        this.formAcordo.controls['valorEntrada'].setValue(valorParcelaUnica);
        this.formAcordo.controls['valorHonorarioEntrada'].setValue(this.getValorHonorarioConsiderar(valorParcelaUnica));
      }
      this.tipoPagamento();
      this.carregarFormasPagamentoDemais();
    }, 1000);
  }

  private getValorHonorarioConsiderar(valorParcela: number): number {
    let percentualHonorario = this.getValorPercentual(this.formAcordo.value['percentualHonorario']);

    if (percentualHonorario) {
        if (this.codigoRamo === 746) {
            let coeficienteDesconto = 1 + (percentualHonorario / 100);
            return Number((valorParcela - (valorParcela / coeficienteDesconto)).toFixed(2));

        } else {
            return Number((valorParcela * percentualHonorario / 100).toFixed(2));
        }
    } else {
        return Number(0);
    }
  }

  private carregarParcelasComJuros(): void {
    console.log('Inicio método carregarParcelasComJuros');
    //TODO verificar pra chamar calculo da divida
    this.carregarParcelas();
  }

  private carregarParcelas(): void {
    console.log('Inicio método carregarParcelas');
    this.verificaEnvioBoletoMensalmente();
    let qtdParcelas = this.formAcordo.value['qtdParcelas'];

    if (this.formAcordo.value['radioEntrada'] === '3') {
      this.formAcordo.controls['qtdParcelas'].setValue(1);
      this.formAcordo.controls['valorEntrada'].setValue(this.formAcordo.value['valorAcordo']);
      this.formAcordo.controls['valorHonorarioEntrada'].setValue(
        this.getValorHonorarioConsiderar(Number(this.formAcordo.value['valorAcordo'])));
      this.limparTabelaParcelas();
      this.formAcordo.controls['qtdParcelas'].setErrors(null);
      return;
    }

    if (!qtdParcelas || qtdParcelas < 0 || qtdParcelas > 100 ||
        this.formAcordo.value['radioEntrada'] == 1 && qtdParcelas < 1 ||
        this.formAcordo.value['radioEntrada'] == 2 && qtdParcelas < 2) {

      this.formAcordo.controls['qtdParcelas'].setErrors({ 'incorrect': true });
      this.limparTabelaParcelas();
      this._submitted = true;
      return;
    }

    let valorAcordo = Number(this.formAcordo.value['valorAcordo']);
    let valorEntrada = Number(0);
    let valorParcela = Number(0);
    let valorParcelaSemJuros = Number(0);
    let valorParcelaJuros = Number(0);
    let valorHonorario = Number(0);
    let dataPrimeiroVencimento = this.formAcordo.value['dataPrimeiroVencimento'];
    let possuiEntrada = this.isPossuiValorEntrada();

    if (possuiEntrada) { //ENTRADA

      if (!this.formAcordo.value['valorEntrada']) {
        this.formAcordo.controls['valorEntrada'].setErrors({ 'incorrect': true });
        this.limparTabelaParcelas();
        this._submitted = true;
        return;
      }

      if (!this.formAcordo.value['codigoFormaPagamentoEntrada']) {
        //this.setMensagemAlert('codigoFormaPagamentoEntrada', 'Informar a forma de pagamento da entrada');
        return;
      }

      if (!this.formAcordo.value['dataVencimentoEntrada']) {
        //this.setMensagemAlert('dataVencimentoEntrada', 'Informar data do vencimento da entrada');
        return;
      }

      let dataVencimentoEntradaSelecionado = moment(this.formAcordo.value['dataVencimentoEntrada'], "DD/MM/YYYY");
      let dataVencimentoEntradaMinimo = moment().add(2, 'days');

      let quantidadeDias = dataVencimentoEntradaSelecionado.diff(dataVencimentoEntradaMinimo, 'days');

      if (quantidadeDias < 0) {
        this.setMensagemAlert('dataVencimentoEntrada', 'Informar data do primeiro vencimento maior/igual que ' + dataVencimentoEntradaMinimo.format("DD/MM/YYYY"));
        this.limparTabelaParcelas();
        return;
      }

      valorEntrada = Number(this.formAcordo.value['valorEntrada']);

      if (valorEntrada <= 0) {
        //this.setMensagemAlert('valorEntrada', 'Informar valor da entrada maior que zero');
        return;
      }

    }

    if (qtdParcelas && qtdParcelas > 0) {
      if (!this.formAcordo.value['codigoFormaPagamento']) {
        //this.setMensagemAlert('codigoFormaPagamento', 'Informar a forma de pagamento');
        return;
      }

      if (!dataPrimeiroVencimento) {
        //this.setMensagemAlert('dataPrimeiroVencimento', 'Informar data do primeiro vencimento');
        return;
      }

      let dataVencimentoSelecionado = moment(dataPrimeiroVencimento, "DD/MM/YYYY");
      let dataVencimentoMinimo = moment().add(2, 'days');

      let quantidadeDias = dataVencimentoSelecionado.diff(dataVencimentoMinimo, 'days');

      if (quantidadeDias < 0) {
        this.setMensagemAlert('dataPrimeiroVencimento', 'Informar data do primeiro vencimento maior/igual que ' + dataVencimentoMinimo.format("DD/MM/YYYY"));
        this.limparTabelaParcelas();
        return;
      }

      if (possuiEntrada) {
        let dataVencimentoEntradaSelecionado = moment(this.formAcordo.value['dataVencimentoEntrada'], "DD/MM/YYYY");
        let dataVencimentoSelecionado = moment(dataPrimeiroVencimento, "DD/MM/YYYY");

        if (dataVencimentoSelecionado < dataVencimentoEntradaSelecionado) {
          this.setMensagemAlert('dataPrimeiroVencimento', 'Informa da data da entrada menor ou igual a data do primeiro vencimento');
          this.limparTabelaParcelas();
          return;
        }

      }
    }

    if (valorAcordo <= 0) {
      this.setMensagemAlert('valorAcordo', 'Informar valor do acordo maior que zero');
      return;
    }

    valorAcordo = valorAcordo - valorEntrada;

    if (valorAcordo) {
      valorParcela = Number((valorAcordo / qtdParcelas).toFixed(2));

      valorParcelaSemJuros = valorParcela;
      valorParcelaJuros = this.getValorJuros(valorParcela, valorAcordo);
      valorParcela = this.getValorParcelaComJuros(valorParcela, valorAcordo);
      valorHonorario = this.getValorHonorarioConsiderar(valorParcela);
      console.log('valorParcelaSemJuros'+valorParcelaSemJuros);
      console.log('valorParcelaJuros'+valorParcelaJuros);
      console.log('valorParcela'+valorParcela);

    }

    if (valorParcela <= 0) {
      this.setMensagemAlert('valorAcordo', 'Verifique os valores da dívida, valor da parcela é menor que zero, verifique o valor do acordo');
      return;
    }

    if (qtdParcelas) {

      this.parcelas = [];
      const parcelasFormArray = this.formAcordo.controls.parcelasForm as FormArray;
      parcelasFormArray.controls = [];

      for (let i = 1; i <= qtdParcelas; i++) {
        let dataVencimento = moment(dataPrimeiroVencimento, "DD/MM/YYYY").add(i - 1, 'M').format("DD/MM/YYYY");
console.log('parcela' + i);
console.log('vlrparcela' + valorParcela);
        parcelasFormArray.push(this.formBuilder.group({
          numeroParcela: (possuiEntrada ? i + 1 : i),
          valorParcela: valorParcela,
          valorParcelaSemJuros: valorParcelaSemJuros,
          valorParcelaJuros: valorParcelaJuros,
          valorParcelaOriginal: valorParcela,
          editada: false,
          dataVencimentoParcela: dataVencimento,
          valorHonorarioPago: valorHonorario
        }));
      }
    }

    if (possuiEntrada) {
      let valorHonorarioEntrada = this.getValorHonorarioConsiderar(valorEntrada);
      var dataVencimentoEntrada = this.formAcordo.value['dataVencimentoEntrada'];

      this.formAcordo.controls['valorHonorarioEntrada'].setValue(valorHonorarioEntrada);
      this.formAcordo.controls['valorEntrada'].setValue(valorEntrada);
      this.formAcordo.controls['dataVencimentoEntrada'].setValue(dataVencimentoEntrada);
    }
    if (!this.formAcordo.value['checkboxComJuros']) {
      this.ajustarUltimaParcelaPorContaArredondamentoCentavos();
    }
  }

  public ajustarUltimaParcelaPorContaArredondamentoCentavos(){
    let valorAcordo = Number(this.formAcordo.value['valorAcordo']);
    const parcelasFormArray = this.formAcordo.controls.parcelasForm as FormArray;

    let qtdparcelas =  parcelasFormArray.controls.length;

    var ultimaParcela = null;
    let valorParcelasArredondadas = Number(0);
    Object.keys(parcelasFormArray.controls).forEach(key => {
        const control = parcelasFormArray.get(key);

        if (control.value['editada'] === false) {
            ultimaParcela = control;
        }
    });

    Object.keys(parcelasFormArray.controls).forEach(key => {
        const control = parcelasFormArray.get(key);

        if(Number(control.value['numeroParcela']) > 0 &&
            control['controls'].numeroParcela.value != ultimaParcela['controls'].numeroParcela.value){
            valorParcelasArredondadas = Number(valorParcelasArredondadas + Number(control['controls'].valorParcela.value.toFixed(2)));
            console.log('valorParcelasArredondadas(1)'+valorParcelasArredondadas);
        }
    });

    if (this.isPossuiValorEntrada()) {
      let valorEntrada = Number(this.formAcordo.value['valorEntrada']);
      valorAcordo = valorAcordo - valorEntrada;
      qtdparcelas =- 1;
    }
    let valorAcordoComJuros = this.getValorAcordoComJuros(valorAcordo, qtdparcelas);
    let novoValor = (valorAcordoComJuros - valorParcelasArredondadas).toFixed(2);
    console.log ('ajustarUltimaParcelaPorContaArredondamentoCentavos - novovalor'+novoValor);
    console.log ('ajustarUltimaParcelaPorContaArredondamentoCentavos - valorParcelasArredondadas'+valorParcelasArredondadas);
    console.log('valorAcordoComJuros'+ valorAcordoComJuros)
    ultimaParcela['controls'].valorParcela.setValue(novoValor);
    ultimaParcela['controls'].valorParcelaOriginal.setValue(novoValor);
  }

  public getBlockFields() {
    return this.acordo && this.acordo.codigoAcordo && this.acordo.codigoAcordo > 0;
  }

  private setMensagemAlert(nomeFormControl: string, mensagem: string, severidade: string = 'warning'): void {
    this.appComponent.createAlert(mensagem, severidade);
    if (nomeFormControl) {
      this.formAcordo.controls[nomeFormControl].setErrors({ 'incorrect': true });
    }
    this._submitted = true;
  }

  public incluirTelefoneDevedor() {
    const control = <FormArray>this.formAcordo.controls['telefonesDevedor'];
    control.push(this.formBuilder.group({ tipoTelefone: '0', telefone: '' }));
  }


  public incluirEmailDevedor() {
    const control = <FormArray>this.formAcordo.controls['emailsDevedor'];
    control.push(this.formBuilder.group({ emailNovoDevedor: '' }));
  }

  public deleteRowTelefone(indexTelefone) {
    const control = <FormArray>this.formAcordo.controls['telefonesDevedor'];
    control.removeAt(indexTelefone);
  }

  public deleteRowEmail(indexEmail) {
    const control = <FormArray>this.formAcordo.controls['emailsDevedor'];
    control.removeAt(indexEmail);
  }

  public getHonorarioFlutuante() {
    if (this.appComponent.codigoRamo == 746 &&
      this.formAcordo.value['anoSinistro'] != undefined &&
      this.formAcordo.value['percentualDesconto'] != undefined &&
      this.formAcordo.value['qtdParcelas'] != undefined) {
      var odmParams: ODMService.ObterPercentualHonorarioFlutuanteParams = {
        anoSinistro: this.formAcordo.value['anoSinistro'],
        descontoConcedido: this.formAcordo.value['percentualDesconto'],
        numeroParcelas: this.formAcordo.value['qtdParcelas'],
        perfil: this.appComponent.perfil
      };

      this.odmService.obterPercentualHonorarioFlutuante(odmParams).subscribe(result => {
        var honorarioFlutuante: HonorarioFlutuante = result;
        this.formAcordo.controls['percentualHonorarioFlutuante'].setValue(honorarioFlutuante.percentualHonorario);
      }, error => {
        const theError: string = error.error.mensagens[2].mensagem;
        this.appComponent.createAlert(theError, 'error');
        console.log('Erro ao consultar honorário no motor de regras!' + error);
      });
    }
  }

  private validarFormularioNovoDevedor(): boolean {

    let isCampoFocus = false;
    var isValido = true;


    if (!this.formAcordo.value['nomeNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['nomeNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('nomeNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (this.formAcordo.get('tipoPessoa').value == 0) {
      if (this.formAcordo.get('cpfNovoDevedor').status === 'INVALID' && !this.formAcordo.get('cpfNovoDevedor').untouched || !this.formAcordo.value['cpfNovoDevedor']) {
        isValido = false;
        this.formAcordo.controls['cpfNovoDevedor'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) {
          document.getElementById('cpfNovoDevedor').focus(); isCampoFocus = true
        };
      }
    } else {
      if (this.formAcordo.get('cnpjNovoDevedor').status === 'INVALID' && !this.formAcordo.get('cnpjNovoDevedor').untouched || !this.formAcordo.value['cnpjNovoDevedor']) {
        isValido = false;
        this.formAcordo.controls['cnpjNovoDevedor'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) {
          document.getElementById('cnpjNovoDevedor').focus(); isCampoFocus = true
        };
      }
    }
    /*
    if (!this.formAcordo.value['scoreDevedor']) {
      isValido = false;
      this.formAcordo.controls['scoreDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('scoreDevedor').focus(); isCampoFocus = true
      };
    }
    */
    if (this.formAcordo.value['telefonesDevedor'].length === 0) {
      isValido = false;
      this.formAcordo.controls['telefonesDevedor'].setErrors({ 'incorrect': true });
    } else {

      var telefonesArray = this.formAcordo.get('telefonesDevedor') as FormArray;
      for (var i = 0; i < telefonesArray.length; i++) {

        if (telefonesArray.value[i].telefone.length < 14) {
          isValido = false;
          this.formAcordo.controls['telefonesDevedor'].setErrors({ 'incorrect': true });
          break;
        }
      }
    }

    if (this.formAcordo.value['emailsDevedor'].length === 0) {
      isValido = false;
      this.formAcordo.controls['emailsDevedor'].setErrors({ 'incorrect': true });
    } else {

      var emailsArray = this.formAcordo.get('emailsDevedor') as FormArray;
      for (var i = 0; i < emailsArray.length; i++) {

        if (emailsArray.value[i].emailNovoDevedor === '') {
          isValido = false;
          this.formAcordo.controls['emailsDevedor'].setErrors({ 'incorrect': true });
          break;
        }

        if (emailsArray.value[i].status === 'INVALID') {
          isValido = false;
          this.formAcordo.controls['emailsDevedor'].setErrors({ 'incorrect': true });
          break;
        }
      }
    }

    if (!this.formAcordo.value['cepNovoDevedor'] || this.formAcordo.value['cepNovoDevedor'].length < 9) {
      isValido = false;
      this.formAcordo.controls['cepNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('cepNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['tipoEnderecoNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['tipoEnderecoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('tipoEnderecoNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['enderecoNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['enderecoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('enderecoNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['numeroNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['numeroNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('numeroNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['bairroNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['bairroNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('bairroNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['cidadeNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['cidadeNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('cidadeNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['estadoNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['estadoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('estadoNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['codigoCategoriaDevedor']) {
      isValido = false;
      this.formAcordo.controls['codigoCategoriaDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('codigoCategoriaDevedor').focus(); isCampoFocus = true
      };
    }

    return isValido;
  }

  public incluirDevedor(componenteModal) {
    if (this.edicaoDevedor) {
      this.alterarDevedor(componenteModal);
    } else {
      console.log("Incluindo novo devedor...");

      this._submittedNovoDevedor = true;

      if (!this.validarFormularioNovoDevedor()) {
        return;
      }
      this.devedor = {};

      //-- Dados basicos
      this.devedor.nome = this.formAcordo.value['nomeNovoDevedor'];
      this.devedor.cpf = (this.formAcordo.value['cpfNovoDevedor'] != undefined)?
                            this.formAcordo.value['cpfNovoDevedor'].replace(/\./g, '').replace('-', '') : null;
      this.devedor.cnpj = (this.formAcordo.value['cnpjNovoDevedor'] != undefined)?
                            CnpjUtils.normalizar(this.formAcordo.value['cnpjNovoDevedor']) : null;
      this.devedor.score = Number(this.formAcordo.value['scoreDevedor']);
      this.devedor.probInadimplencia = Number(this.formAcordo.value['probInadimDevedor']);
      this.devedor.flagNegativado = this.formAcordo.value['negativadoNovoDevedor'];
      this.devedor.flagCongenere = this.formAcordo.value['congenereNovoDevedor'];
      this.devedor.flagPagador = null;
      if (this.formAcordo.get('tipoPessoa').value === '0') {
        this.devedor.strCpfGrid = this.formAcordo.value['cpfNovoDevedor'].replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"$1.$2.$3-$4");
        this.devedor.tipoPessoa = TipoPessoaEnum.FISICA;
      } else {
        this.devedor.strCpfGrid = CnpjUtils.formatar(this.formAcordo.value['cnpjNovoDevedor']);
        this.devedor.tipoPessoa = TipoPessoaEnum.JURIDICA;
      }

      //-- Telefones
      this.devedor.telefones = [];
      var telefonesArray = this.formAcordo.get('telefonesDevedor') as FormArray;
      this.devedor.strTelefoneGrid = telefonesArray.value[0].telefone.toString();
      for (var i = 0; i < telefonesArray.length; i++) {

        this.devedor.telefones[i] = {};
        this.devedor.telefones[i].codigoDDDTelefone = telefonesArray.value[i].telefone.toString().substring(1, 3);
        this.devedor.telefones[i].numeroTelefone =
          telefonesArray.value[i].telefone.toString().substring(4, telefonesArray.value[i].telefone.length).replace('-', '').trim();

        if (telefonesArray.value[i].tipoTelefone == 0) {
          this.devedor.telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.FIXO;
        } else if (telefonesArray.value[i].tipoTelefone == 1) {
          this.devedor.telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.CELULAR;
        }
      }

      //-- Emails
      this.devedor.emails = [];
      var emailsArray = this.formAcordo.get('emailsDevedor') as FormArray;
      for (var i = 0; i < emailsArray.length; i++) {

        this.devedor.emails[i] = {};
        this.devedor.emails[i].endereco = emailsArray.value[i].emailNovoDevedor.toString();
      }

      //-- Endereco
      this.devedor.endereco = {};
      this.devedor.endereco.codigoEndereco = this.formAcordo.value['codigoEndereco'];
      this.devedor.endereco.cep = this.formAcordo.value['cepNovoDevedor'];
      this.devedor.endereco.tipoEndereco = this.formAcordo.value['tipoEnderecoNovoDevedor'];
      this.devedor.endereco.logradouro = this.formAcordo.value['enderecoNovoDevedor'];
      this.devedor.endereco.numero = this.formAcordo.value['numeroNovoDevedor'];
      this.devedor.endereco.complemento = this.formAcordo.value['complementoNovoDevedor'];
      this.devedor.endereco.bairro = this.formAcordo.value['bairroNovoDevedor'];
      this.devedor.endereco.cidade = this.formAcordo.value['cidadeNovoDevedor'];
      this.devedor.endereco.estado = this.formAcordo.value['estadoNovoDevedor'];

      //-- Categoria
      this.devedor.codigoCategoriaDevedor = this.formAcordo.value['codigoCategoriaDevedor'];

      //-- Adiciona na lista de devedores
      this.devedores.push(this.devedor);
      this.devedor = null;

      if(this.devedores.length > 1) {
        let element: HTMLInputElement = document.getElementsByName("radioPagador")[0] as HTMLInputElement;
        element.checked = false;
        this.devedores[0].flagPagador = null;
        this.formAcordo.controls['flagPagador'].setValue(null);
        this.FlagTerceiro = false;
      }
      componenteModal.close();
    }
  }

  public alterarDevedor(componenteModal) {
    console.log("Alterando devedor no grid...");
    this._submittedNovoDevedor = true;
    if (!this.validarFormularioNovoDevedor()) {
      return;
    }
    //-- Dados basicos
    this.devedores[this.indexEdicaoDevedor].nome = this.formAcordo.value['nomeNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].cpf = this.formAcordo.value['cpfNovoDevedor'].replace(/\./g, '').replace('-', '');
    this.devedores[this.indexEdicaoDevedor].cnpj = CnpjUtils.normalizar(this.formAcordo.value['cnpjNovoDevedor']);
    this.devedores[this.indexEdicaoDevedor].score = Number(this.formAcordo.value['scoreDevedor']);
    this.devedores[this.indexEdicaoDevedor].probInadimplencia = Number(this.formAcordo.value['probInadimDevedor']);
    this.devedores[this.indexEdicaoDevedor].flagNegativado = this.formAcordo.value['negativadoNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].flagCongenere = this.formAcordo.value['congenereNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].flagPagador = null;
    if (this.formAcordo.get('tipoPessoa').value === '0') {
      this.devedores[this.indexEdicaoDevedor].strCpfGrid = this.formAcordo.value['cpfNovoDevedor'].replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"$1.$2.$3-$4");
      this.devedores[this.indexEdicaoDevedor].tipoPessoa = TipoPessoaEnum.FISICA;
    } else {
      this.devedores[this.indexEdicaoDevedor].strCpfGrid = CnpjUtils.formatar(this.formAcordo.value['cnpjNovoDevedor']);
      this.devedores[this.indexEdicaoDevedor].tipoPessoa = TipoPessoaEnum.JURIDICA;
    }

    //-- Telefones
    this.devedores[this.indexEdicaoDevedor].telefones = [];
    var telefonesArray = this.formAcordo.get('telefonesDevedor') as FormArray;
    this.devedores[this.indexEdicaoDevedor].strTelefoneGrid = telefonesArray.value[0].telefone.toString();
    for (var i = 0; i < telefonesArray.length; i++) {

      this.devedores[this.indexEdicaoDevedor].telefones[i] = {};
      this.devedores[this.indexEdicaoDevedor].telefones[i].codigoDDDTelefone = telefonesArray.value[i].telefone.toString().substring(1, 3);
      this.devedores[this.indexEdicaoDevedor].telefones[i].numeroTelefone =
        telefonesArray.value[i].telefone.toString().substring(4, telefonesArray.value[i].telefone.length).replace('-', '').trim();

        if (telefonesArray.value[i].tipoTelefone == 0) {
          this.devedores[this.indexEdicaoDevedor].telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.FIXO;
        } else if (telefonesArray.value[i].tipoTelefone == 1) {
          this.devedores[this.indexEdicaoDevedor].telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.CELULAR;
        }
    }

    //-- Emails
    this.devedores[this.indexEdicaoDevedor].emails = [];
    var emailsArray = this.formAcordo.get('emailsDevedor') as FormArray;
    for (var i = 0; i < emailsArray.length; i++) {

      this.devedores[this.indexEdicaoDevedor].emails[i] = {};
      this.devedores[this.indexEdicaoDevedor].emails[i].endereco = emailsArray.value[i].emailNovoDevedor.toString();
    }

    //-- Endereco
    this.devedores[this.indexEdicaoDevedor].endereco.codigoEndereco = this.formAcordo.value['codigoEndereco'];
    this.devedores[this.indexEdicaoDevedor].endereco.cep = this.formAcordo.value['cepNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].endereco.tipoEndereco = this.formAcordo.value['tipoEnderecoNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].endereco.logradouro = this.formAcordo.value['enderecoNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].endereco.numero = this.formAcordo.value['numeroNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].endereco.complemento = this.formAcordo.value['complementoNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].endereco.bairro = this.formAcordo.value['bairroNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].endereco.cidade = this.formAcordo.value['cidadeNovoDevedor'];
    this.devedores[this.indexEdicaoDevedor].endereco.estado = this.formAcordo.value['estadoNovoDevedor'];

    //-- Categoria
    this.devedores[this.indexEdicaoDevedor].codigoCategoriaDevedor = this.formAcordo.value['codigoCategoriaDevedor'];

    //-- Adiciona na lista de devedores
    this.devedor = null;

    componenteModal.close();
   }


  public pesquisarCEP() {

    this.formAcordo.controls['codigoEndereco'].setValue(null);
    var cep = this.formAcordo.value['cepNovoDevedor'];

    console.log("Consultando o cep : " + cep);

    //-- So busca o cep se for digitado corretamente
    if (cep.length === 9) {

      var cepInicial = cep.substring(0, 5);
      var cepFinal = cep.substring(6, 9);

      var params: GuiaPostalService.ObterLogradourosParams = { numeroCepLogradouro: cepInicial, numeroCepComplementoLogradouro: cepFinal };

      this.guiaPostalService.obterLogradouros(params).subscribe(response => {

        this.formAcordo.controls['codigoEndereco'].setValue(response.logradouros[0].codigoLogradouro);
        this.formAcordo.controls['tipoEnderecoNovoDevedor'].setValue(
          response.logradouros[0].tipoLogradouro.nomeTipoLogradouro);
        this.formAcordo.controls['enderecoNovoDevedor'].setValue(
          response.logradouros[0].nomeLogradouro);
        this.formAcordo.controls['bairroNovoDevedor'].setValue(
          response.logradouros[0].bairro.nomeBairro);
        this.formAcordo.controls['cidadeNovoDevedor'].setValue(
          response.logradouros[0].localidade.nomeLocalidade);
        this.formAcordo.controls['estadoNovoDevedor'].setValue(
          response.logradouros[0].localidade.estado.siglaEstado);

      }, error => {
        this.appComponent.createAlert('Não foi possível obter o endereço pelo CEP.', 'error');
        console.log('Não foi possível obter o endereço  pelo CEP: ' + error);
      });
    }
  }

  public formaPagamentoSeleciona(event){

    this.formAcordo.controls['codigoFormaPagamentoEntrada'].setValue(this.formAcordo.value['formaPagamentoEntrada']); // Fixo - Boleto;
    this.formAcordo.controls['codigoFormaPagamento'].setValue(this.formAcordo.value['formaPagamentoEntrada']); // Fixo - Boleto;
    //BOLETO
    console.log('forma pagto entrada '+ this.formAcordo.value['formaPagamentoEntrada']);

    if(this.formAcordo.value['formaPagamentoEntrada'] == 1){
      this.pagamentoBoleto = true;
    }else{
      this.pagamentoBoleto = false;
    }

  }

  public efetivarAcordo(componenteModalGravando): void {

    console.log("Efetivando acordo....");

    setTimeout(() => {
      console.log("Efetuando a gravacao do Acordo..."+ new Date().toDateString());
      this.efetivarAcordoImpl(componenteModalGravando);
    }, 1500);

    componenteModalGravando.open("save");
  }

  private efetivarAcordoImpl(componenteModalGravando){

        this.acordoService.salvarAcordo(this.acordo)
          .subscribe((data: any) => {

            componenteModalGravando.close();
            this.modalGeraAcordo.close();
            //this.appComponent.createAlert('Acordo de número '+ data.codigo + ' efetivado com sucesso!', 'success');
            this.modalConcluidoAcordo.open(null);
            this.acordo.codigoAcordo = data.codigo;
            this.acordo.codigoAcordoSistema = data.codigoAcordoSistema;

            this.pagamentoBoleto = false; // SET INITIAL VALUE
            if (this.formAcordo.value['radioEntrada'] == 1 || this.formAcordo.value['radioEntrada'] == 3 ) {
              if (this.formAcordo.value['codigoFormaPagamentoEntrada'] == 1) {
                this.pagamentoBoleto = true;
              }
            } else {
              if (this.formAcordo.value['radioEntrada'] == 2 ) { // SEM ENTRADA
                if (this.formAcordo.value['codigoFormaPagamento'] == 1) {
                  this.pagamentoBoleto = true;
                }
              }
            }

            console.log('É pgto boleto ?'+ this.pagamentoBoleto )
            if(this.pagamentoBoleto === true){
              if(data.urlBoleto != null) {
                this.exibirModalBoleto = true;
                let codigoBase64 = data.urlBoleto;
                this.base64Pdf = 'data:application/pdf;base64,' + codigoBase64;
                this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.base64Pdf);
                console.log("Boleto: "+ this.pdfUrl);
              }
             }

          }, error => {
            componenteModalGravando.close();
            // Erro Acordo
            if(error.error != undefined && error.error.mensagem != undefined){
              this.appComponent.createAlert(error.error.mensagem.message, 'error');
            } else if (error.indexOf("Unauthorized") > 0) {
              this.appComponent.createAlert('Perfil não possui acesso a aplicação, favor verificar com administrador', 'error');
            } else  {
              this.appComponent.createAlert('Ocorreu um erro ao gerar o Acordo. Tente novamente mais tarde.', 'error');
            }
            console.log('Erro ao efetivar o acordo!' + error);
          });

  }

  habilitarBotaoAcordo(){
    return this.acordo.codigoAcordo != null && this.acordo.temAlcada;
  }


  private carregarAcordo(acordo: Acordo) {

    this.formAcordo.controls['dataDivida'].setValue(moment(acordo.dataDivida, "YYYY-MM-DD").format("DD/MM/YYYY"));

    let devedores = acordo.devedores;

    if(devedores != undefined){
      for (let i = 0; i < devedores.length; i++) {
        if (devedores[i].endereco.complemento != undefined) {
          devedores[i].endereco.complemento = devedores[i].endereco.complemento.trim().substring(0,9);
        }
        if (devedores[i].endereco.bairro != undefined) {
          devedores[i].endereco.bairro = devedores[i].endereco.bairro.trim().substring(0,39);

        }
        if (devedores[i].endereco.numero != undefined) {
          if (devedores[i].endereco.numero.trim().length == 0) {
            devedores[i].endereco.numero = undefined
          } else
          {
            if (devedores[i].endereco.numero === undefined)
              devedores[i].endereco.numero = '0'
            else
              devedores[i].endereco.numero = devedores[i].endereco.numero.replace(/[^0-9]*/g, '')
          }
        }

        this.devedores.push(devedores[i]);
        if (devedores[i].cnpj == null && devedores[i].cpf == null){
          this.devedores.splice(this.devedores.indexOf(devedores[i]),1);
        }
      }
    } else {
      this.appComponent.createAlert('Não foram encontrados terceiros para este sinistro no legado!.', 'warning');
      console.log("Legado nao retornou os terceiros!");
    }

    this.formAcordo.controls['codigoSucursal'].setValue(acordo.processoRessarcimento.codigoSucursal);
    this.formAcordo.controls['codigoEscritorio'].setValue(acordo.codigoEscritorio);
    this.formAcordo.controls['escritorio'].setValue(acordo.nomeEscritorio);
    //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
    //this.formAcordo.controls['codigoMarca'].setValue(acordo.codigoMarca);
    if(this.flagSinistroItau != undefined && this.flagSinistroItau != null && this.flagSinistroItau == 'S') {
      this.formAcordo.controls['codigoMarca'].setValue(3);
      this.formAcordo.controls['codigoSinistroItau'].setValue(this.codigoSinistroItau);
    } else {
      this.formAcordo.controls['codigoMarca'].setValue(acordo.codigoMarca);
    }
    //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
    this.formAcordo.controls['percentualCorrecaoNegociacao'].setValue(0.0);

    this.formAcordo.controls['valorAtualDivida'].setValue(acordo.valorAtualDivida);
    this.formAcordo.controls['despesasCustas'].setValue(acordo.valorDespesaProcesso);
    if( this.codigoRamo == 531 ) {
        this.formAcordo.controls['valorVendaSalvado'].setValue(acordo.valorSalvados);
        this.formAcordo.controls['valorRecuperado'].setValue(acordo.valorRecuperado);
    } else if( this.codigoRamo == 746 ) {
        this.formAcordo.controls['valorRecuperado'].setValue(acordo.valorSalvados);
    }
    this.formAcordo.controls['valorAtualizado'].setValue(acordo.valorRessarcimentoRealizado);
    this.carregarDadosParcelasAcordo(acordo);

    //-- Origem RE - seta o escritorio e sucursal baseado no parametro
    if( this.isEscritorio ) {
        this.formAcordo.controls['codigoEscritorio'].setValue( this.codigoEscritorio );
        this.formAcordo.controls['escritorio'].setValue( this.nomeEscritorio );
    } else {
        if(this.sistemaOrigemParametro == 1){
            this.formAcordo.controls['codigoSucursal'].setValue(this.codigoSucursalRE);
            if (acordo.codigoEscritorio != 1){
                this.formAcordo.controls['codigoEscritorio'].setValue(this.codigoEscritorioRE);
                this.formAcordo.controls['escritorio'].setValue(this.nomeEscritorioRE);
            }
        }
    }
    //this.formAcordo.controls['valorVendaSalvado'].disable();
    this.flagVenda = acordo.flagVenda;
    console.log(this.flagVenda);

    this.carregarDinamicaAcordo(this.listaDinamicas, acordo.dinamica);

    if (acordo.dinamica != undefined) {
      this.formAcordo.controls['dinamica'].setValue(acordo.dinamica);
    }
  }

  private carregarDadosParcelasAcordo(acordo: Acordo): void {
    const parcelasAcordo = acordo.parcelaLista && acordo.parcelaLista.parcelas ? acordo.parcelaLista.parcelas : [];
    const parcelasEntrada = parcelasAcordo.filter(parcela =>
      parcela.numeroParcela === 0 ||
      parcela.tipoParcela && parcela.tipoParcela.codigoTipoParcela === TipoParcelaAcordoEnum.ENTRADA);
    const parcelaEntrada = parcelasEntrada.length > 0 ? parcelasEntrada[0] : null;
    const parcelasDemais = parcelasAcordo.filter(parcela => parcelasEntrada.indexOf(parcela) === -1);
    const parcelasFormArray = this.formAcordo.controls.parcelasForm as FormArray;

    parcelasFormArray.controls = [];

    if (parcelaEntrada && parcelasDemais.length > 0) {
      this.formAcordo.controls['radioEntrada'].setValue('1');
    } else if (parcelaEntrada) {
      this.formAcordo.controls['radioEntrada'].setValue('3');
    } else {
      this.formAcordo.controls['radioEntrada'].setValue('2');
    }

    const quantidadeParcelas = this.formAcordo.value['radioEntrada'] === '3' ? 1 :
      parcelasDemais.length > 0 ? parcelasDemais.length : acordo.qtdParcelas;
    this.formAcordo.controls['qtdParcelas'].setValue(quantidadeParcelas || null);

    if (parcelaEntrada) {
      this.formAcordo.controls['valorEntrada'].setValue(parcelaEntrada.valorParcela);
      this.formAcordo.controls['valorHonorarioEntrada'].setValue(parcelaEntrada.valorHonorarioPago);
      this.formAcordo.controls['dataVencimentoEntrada'].setValue(
        this.getDataFormatada(parcelaEntrada.dataVencimentoParcela));
      this.formAcordo.controls['codigoFormaPagamentoEntrada'].setValue(
        parcelaEntrada.formaPagamento && parcelaEntrada.formaPagamento.codigoFormaPagamento);
    }

    parcelasDemais.forEach(parcela => {
      const valorParcelaSemJuros = parcela.valorParcelaSemJuros != null ?
        parcela.valorParcelaSemJuros : parcela.valorParcela;
      parcelasFormArray.push(this.formBuilder.group({
        numeroParcela: parcela.numeroParcela,
        valorParcela: parcela.valorParcela != null ? parcela.valorParcela : valorParcelaSemJuros,
        valorParcelaSemJuros: valorParcelaSemJuros,
        valorParcelaJuros: parcela.valorParcelaJuros || 0,
        valorParcelaOriginal: parcela.valorParcela != null ? parcela.valorParcela : valorParcelaSemJuros,
        editada: false,
        dataVencimentoParcela: this.getDataFormatada(parcela.dataVencimentoParcela),
        valorHonorarioPago: parcela.valorHonorarioPago || 0
      }));
    });

    if (parcelasDemais.length > 0) {
      this.formAcordo.controls['codigoFormaPagamento'].setValue(
        parcelasDemais[0].formaPagamento && parcelasDemais[0].formaPagamento.codigoFormaPagamento);
      this.formAcordo.controls['dataPrimeiroVencimento'].setValue(
        this.getDataFormatada(parcelasDemais[0].dataVencimentoParcela));
    }

    const parcelaComJuros = parcelasAcordo.length > 0 ? parcelasAcordo[0] : null;
    this.formAcordo.controls['checkboxComJuros'].setValue(
      parcelaComJuros && parcelaComJuros.flagCobrancaJuroAtraso === AppConstantes.FLAG_SIM);
    this.formAcordo.controls['percentualJurosParcela'].setValue(acordo.percentualTaxaJuroParcela);
    this.formAcordo.controls['checkboxgAcordoEscalonado'].setValue(
      acordo.flagAcordoEscalonado === AppConstantes.FLAG_SIM);

    this.tipoPagamento();
    this.carregarFormasPagamentoDemais();
  }

  private getValorJurosParcela(parcela: Parcela): number {
    let valorParcelaComJuros = Number(0);
    if (AppConstantes.FLAG_SIM === parcela.flagCobrancaJuroAtraso) {
      valorParcelaComJuros = parcela.valorParcela * 1 / 100;
    }
    return valorParcelaComJuros;
  }

  private getDataFormatada(data: any): string {
    let dataFormatada = '';
    if (data && data !== '') {
      dataFormatada = moment(data, "YYYY-MM-DD").format("DD/MM/YYYY")
    }
    return dataFormatada;
  }

  //filtra a dinamica retornada em acordo
  private carregarDinamicaAcordo(listaDinamicas: Dinamica[] , idDinamica: number ): void {

    if(idDinamica != null) {
      this.dinamicaAcordo =  listaDinamicas.filter((dinamica) => { return dinamica.idDinamica == idDinamica;  });
    }
  }

  public modalConcluidoAcordoClick(){
    setTimeout(() => {
      this.router.navigate(['/consultar-proposta/'+this.acordo.codigoAcordoSistema]);
    }, 500);
  }

  public modalConcluidoPropostaClick(){
    setTimeout(() => {
      this.router.navigate(['/consultar-proposta/'+this.acordo.codigoAcordoSistema]);
    }, 500);
  }

  public obterHonorarios(event){

    if( this.codigoRamo == 531 ) {
        if( this.formAcordo.value['codigoTipoRecebimento'] && this.formAcordo.value['codigoTipoRecebimento'] != '' &&
            this.formAcordo.value['codigoProcedencia'] && this.formAcordo.value['codigoProcedencia'] != '' &&
            this.formAcordo.value['codigoTipoOrigem'] && this.formAcordo.value['codigoTipoOrigem'] != '' &&
            this.formAcordo.value['dinamica'] && this.formAcordo.value['dinamica'] != '' &&
            this.formAcordo.value['escritorio'] && this.formAcordo.value['escritorio'] != '' ) {

            this.criarObjetoAcordo();

            this.propostaService.obterHonorarios(this.acordo).subscribe(data => {
                this.appComponent.createAlert('Cálculo de honorários realizado com sucesso.', 'success');
                console.info("data:" + data);
                this.formAcordo.controls['percentualHonorario'].setValue( data );
                this.calcularValorAtualizado();
            }, message => {
                this.appComponent.createAlert(message.error.message, 'error');
                console.log(message.error.message);
            } );
        }
    } else if( this.codigoRamo == 746 ) {
        if( this.formAcordo.value['codigoTipoRecebimento'] && this.formAcordo.value['codigoTipoRecebimento'] != '' &&
            this.formAcordo.value['codigoProcedencia'] && this.formAcordo.value['codigoProcedencia'] != '' &&
            this.formAcordo.value['codigoTipoOrigem'] && this.formAcordo.value['codigoTipoOrigem'] != '' &&
            this.formAcordo.value['escritorio'] && this.formAcordo.value['escritorio'] != '' ) {
            this.criarObjetoAcordo();

            if(this.desabilitarPainelNegociacao[2] == false && this.habilitarPercentualDesconto[2] == false){
              this.propostaService.obterHonorarios(this.acordo).subscribe(data => {
                    this.appComponent.createAlert('Calculo de honorários realizado com sucesso.', 'success');
                    console.info("data:" + data);
                    this.formAcordo.controls['percentualHonorario'].setValue( data );
                    this.calcularValorAtualizado();
                }, message => {
                    this.appComponent.createAlert(message.error.message, 'error');
                    console.log(message.error.message);
                } );
            }

        }
    }
  }

  private bloqueiaCamposLegado(): void {
    this.bloqueiaDadosLegado = true;

    if (this.formAcordo.controls['dataDivida'].value === 'Invalid date') {
    this.bloqueiaDataDivida = false;
    }

    if (this.formAcordo.controls['valorAtualDivida'].value === 0 && this.formAcordo.controls['valorAtualDivida'].value !== null && this.formAcordo.controls['valorAtualDivida'].value !== undefined ) {
    this.bloqueiaVlrDivida = false;
    }

  }
  private origemChanged(){
    if (this.codigoRamo == 531) {
      if (this.formAcordo.controls['codigoTipoOrigem'].value === '1' ) {
        this.bloqueiaVlrDivida = false;

      } else {
        this.bloqueiaVlrDivida = true;
        this.bloqueiaCamposLegado();
      }
    }
  }
  private  verificaEnvioBoletoMensalmente(): void {
    console.log('cd forma pagto'+ this.formAcordo.controls['codigoFormaPagamento'].value)
    if (this.formAcordo.controls['codigoFormaPagamento'].value == 1 )
    //this.formAcordo.controls['flagEnvioBoletoMensal'].enable()
    this.bloqueiaEnvioBoleto = false;
    else
    //this.formAcordo.controls['flagEnvioBoletoMensal'].disable();
    this.bloqueiaEnvioBoleto = true;
 }

 public consultarScoreSerasa() {

    var scoreParams: DevedoresService.ObterScoreSerasaParams = {
      cpfCnpj: this.formAcordo.get('tipoPessoa').value === '0' ? this.formAcordo.controls['cpfNovoDevedor'].value  : this.formAcordo.controls['cnpjNovoDevedor'].value  ,
      codigoRamo: this.appComponent.codigoRamo
    };

    this._submittedScoreSerasa = true;
    this.isSerasaLoading = true;
    this.devedoresService.obterScoreSerasa(scoreParams).subscribe(result => {
      var scoreserasa: ScoreSerasa = result;
      this.formAcordo.controls['scoreDevedor'].setValue(scoreserasa.score);
      this.formAcordo.controls['probInadimDevedor'].setValue(scoreserasa.percentualInadimplecia);
      this.isSerasaLoading = false;
    }, error => {
      this.isSerasaLoading = false;
      const theError: string = 'Documento não localizado';
      this.appComponent.createAlert(theError, 'error');

    });
  }


  public getSubmittedScoreSerasa() {
    return this._submittedScoreSerasa;
  }

    //Regra do SAP:
    //Não é possível realizar a prorrogação com a data solicitada. Somente será possível realizar uma prorrogação até  30  dias após o vencimento.
    //Bloquear o calendário considerando os 30 dias corridos após o vencimento.

  private formaPagtoChanged() {
     if (this.formAcordo.controls['codigoFormaPagamento'].value == 4) {
      var minDate = new Date();
      minDate.setDate(minDate.getDate() + 8);
      this.dataMinimaSelecaoDemais = moment(minDate, "DD/MM/YYYY").format("DD/MM/YYYY");
      this.formAcordo.controls['dataPrimeiroVencimento'].setValue(null);
     } else {
      //this.dataMinimaSelecaoDemais = null;
      var minDate = new Date();
      minDate.setDate(minDate.getDate() + 3);
      this.dataMinimaSelecaoDemais = moment(minDate, "DD/MM/YYYY").format("DD/MM/YYYY");
      this.formAcordo.controls['dataPrimeiroVencimento'].setValue(null);
     }
  }

  private formaPagtoEntradaChanged() {

    if (this.formAcordo.controls['codigoFormaPagamentoEntrada'].value == 4) {
      var minDate = new Date();
      minDate.setDate(minDate.getDate() + 8);
      this.dataMinimaSelecaoEntrada = moment(minDate, "DD/MM/YYYY").format("DD/MM/YYYY");

    this.formAcordo.controls['dataVencimentoEntrada'].setValue(null);
    } else {
      //this.dataMinimaSelecaoEntrada = null;
      var minDate = new Date();
      minDate.setDate(minDate.getDate() + 3);
      this.dataMinimaSelecaoEntrada = moment(minDate, "DD/MM/YYYY").format("DD/MM/YYYY");
    }
  }

  private verificarCamposHonorarios() {
    if( this.codigoRamo == 746 ) {
      if ((this.formAcordo.controls['codigoProcedencia'].value == null || this.formAcordo.controls['codigoProcedencia'].value == '') || (this.formAcordo.controls['codigoTipoOrigem'].value == null || this.formAcordo.controls['codigoTipoOrigem'].value == '') || (this.formAcordo.controls['codigoTipoRecebimento'].value == null  || this.formAcordo.controls['codigoTipoRecebimento'].value == '') ) {
        this.appComponent.createAlert("Por favor, selecione o tipo de acordo, procedência e origem!", "alert");
        this.formAcordo.controls['radioEntrada'].setValue(undefined);
      }
   }  else if( this.codigoRamo == 531 ) {
    if ((this.formAcordo.controls['codigoProcedencia'].value == null || this.formAcordo.controls['codigoProcedencia'].value == '') || (this.formAcordo.controls['codigoTipoOrigem'].value == null || this.formAcordo.controls['codigoTipoOrigem'].value == '') || (this.formAcordo.controls['codigoTipoRecebimento'].value == null  || this.formAcordo.controls['codigoTipoRecebimento'].value == '') || (this.formAcordo.controls['dinamica'].value == null  || this.formAcordo.controls['dinamica'].value == '') ) {
      this.appComponent.createAlert("Por favor, selecione o tipo de acordo, procedência, origem e dinâmica!", "alert");
      this.formAcordo.controls['radioEntrada'].setValue(undefined);
    }

   }
  }
  private zerarValores() {
     this.formAcordo.controls['valorAcordo'].setValue(0);
     this.formAcordo.controls['desmembramento'].setValue(0);
     //Valor do Prejuízo
     // this.formAcordo.controls['valorAtualDivida'].setValue(0);
      //Venda/Estimativa de Salvados
      //this.formAcordo.controls['valorVendaSalvado'].setValue(0);
      //Desconto Despesas/Custas
      this.formAcordo.controls['descontoDespesasCustas'].setValue(0);
      //Despesas/Custas
      if (this.codigoRamo == 531) {
        this.formAcordo.controls['despesasCustas'].setValue(0);
      }
      //% Honorário
      this.formAcordo.controls['percentualHonorario'].setValue(0);
      this.formAcordo.controls['lmi'].setValue(0);
      this.formAcordo.controls['desmembramento'].setValue(0);
      //Diferença
      this.formAcordo.controls['valorAtualizadoDiferencaOriginal'].setValue(0);
      //À Ressarcir
      this.formAcordo.controls['valorAtualizadoOriginal'].setValue(0);
      //Diferença
      this.formAcordo.controls['valorAtualizado'].setValue(0);
      //
      this.formAcordo.controls['percentualCorrecaoNegociacao'].setValue(0);
      //
      this.formAcordo.controls['percentualDesconto'].setValue(0);
      //Valor do Desconto
      this.formAcordo.controls['valorDiferencaDivida'].setValue(0);
      //"Valor Atualizado C/ Desconto
      this.formAcordo.controls['valorAtualizadoComDesconto'].setValue(0);
      //Valor do Honorário
      this.formAcordo.controls['valorDiferencaComHonorario'].setValue(0);
      //
      this.formAcordo.controls['nomeCongenere'].setValue(null);
  }
   public bloquear(nomeControlNegociacao: string){
  if (nomeControlNegociacao == 'percentualDesconto') {
    this.bloqueiaNegociacaopercentualDesconto = false;
    this.bloqueiaNegociacaovalorDiferencaDivida = true;
    this.bloqueiaNegociacaovalorAcordo = true;
  }
  if (nomeControlNegociacao == 'valorDiferencaDivida') {
    this.bloqueiaNegociacaopercentualDesconto = true;
    this.bloqueiaNegociacaovalorDiferencaDivida = false;
    this.bloqueiaNegociacaovalorAcordo = true;
  }
  if (nomeControlNegociacao == 'valorAcordo') {
    this.bloqueiaNegociacaopercentualDesconto = true;
    this.bloqueiaNegociacaovalorDiferencaDivida = true;
    this.bloqueiaNegociacaovalorAcordo = false;
  }
      }


      public ProximoInformacoesGerais(){
    
        if(this.formAcordo.controls['codigoRamoSinistro'].value != null && this.formAcordo.controls['codigoRamoSinistro'].value != '' &&
          this.formAcordo.controls['numeroSinistro'].value != null && this.formAcordo.controls['numeroSinistro'].value != '' &&
          this.formAcordo.controls['anoSinistro'].value != null && this.formAcordo.controls['anoSinistro'].value != '' &&
          this.formAcordo.controls['sequenciaItemSinistro'].value != null && this.formAcordo.controls['sequenciaItemSinistro'].value != '' &&
          this.formAcordo.controls['codigoSucursal'].value != null && this.formAcordo.controls['codigoSucursal'].value != '' && 
          this.formAcordo.controls['escritorio'].value != null && this.formAcordo.controls['escritorio'].value != '' &&
          this.formAcordo.controls['codigoMarca'].value != null && this.formAcordo.controls['codigoMarca'].value != null ){
          this.InformacoesGerais = false;
          this.Terceiro = true;
          this.DadosAcordo = false;
          this.Valores = false;
          this.Negociacao = false;
          this.CondicoesPagamento = false;
          this.ConfirmarGerar = false;
        }else{
          this.appComponent.createAlert('Dados incorretos favor verificar se os dados de Ramo, Sinistro, Ano, Item, Sucursal, Escritório e Marca estão incompletos.', 'error');
        }
          }

public ProximoTerceiro(){
      if (this.FlagTerceiro == true){ // Alterar para ==
      this.InformacoesGerais = false;
      this.Terceiro = false;
      this.DadosAcordo = true;
      this.Valores = false;
      this.Negociacao = false;
      this.CondicoesPagamento = false;
      this.ConfirmarGerar = false;
      
      }else{
        this.appComponent.createAlert('Selecione um Terceiro na parte de Pagador.', 'error');
      }
        }
        public ProximoDadosAcordo(){
          if (this.tipoAcordoSelecionado == true && this.formAcordo.value['dinamica'] != 'Selecione...' && this.formAcordo.value['dinamica'] != '' && this.formAcordo.value['dinamica'] != null){
            this.InformacoesGerais = false;
            this.Terceiro = false;
            this.DadosAcordo = false;
            this.Valores = true;
            this.Negociacao = false;
            this.CondicoesPagamento = false;
            this.ConfirmarGerar = false;
      }else{
        this.appComponent.createAlert('Verifique se está preenchido os campos de Tipo de Acordo, Procedência, Origem e Dinâmica e caso possua Congênere favor informar.', 'error');
      }
          }
          public ProximoValores(){ //Falta ainda
            if(this.formAcordo.controls['dataDivida'].value != null && 
              this.formAcordo.controls['valorAtualDivida'].value != null && this.formAcordo.controls['valorAtualDivida'].value != 0 && 
              this.formAcordo.controls['percentualHonorario'].value != null && 
              this.formAcordo.controls['valorAtualizado'].value != 0 && this.formAcordo.controls['valorAtualizado'].value != null
              ){
                if(this.formAcordo.get('codigoProcedencia').value == 1){
                  if(this.formAcordo.controls['valorAtualizado'].value!= null && this.formAcordo.controls['valorAtualizado'].value!= 0 &&
                    this.formAcordo.controls['valorAtualizadoOriginal'].value!= null && this.formAcordo.controls['valorAtualizadoOriginal'].value!= 0 
                    ){ 
                    this.InformacoesGerais = false;
                    this.Terceiro = false;
                    this.DadosAcordo = false;
                    this.Valores = false;
                    this.Negociacao = true;
                    this.CondicoesPagamento = false; 
                    this.ConfirmarGerar = false;
                  }else{
                    this.appComponent.createAlert('Preencha todos os campos para prosseguir como Data do Sinistro, Valor do Prejuízo, % Honorário, À Ressarcir e Valor Atualizado.', 'error');
                   }
                }else{
                  this.InformacoesGerais = false;
                  this.Terceiro = false;
                  this.DadosAcordo = false;
                  this.Valores = false;
                  this.Negociacao = true;
                  this.CondicoesPagamento = false;
                  this.ConfirmarGerar = false;
                }
              }else{
                this.appComponent.createAlert('Preencha todos os campos para prosseguir como Data do Sinistro, Valor do Prejuízo, % Honorário e À Ressarcir.', 'error');
              }
            }
            
            public ProximoNegociacao(){
              if (this.formAcordo.value['valorAcordo'] != 0){
                this.InformacoesGerais = false;
                this.Terceiro = false;
                this.DadosAcordo = false;
                this.Valores = false;
                this.Negociacao = false;
                this.CondicoesPagamento = true;
                this.ConfirmarGerar = false;
              }else{
                this.appComponent.createAlert('Valor do Acordo não pode ser R$ 0,00', 'error');
              }
                  }

                  public ProximoCondicoesPagamento(){
                    if(this.formAcordo.get('radioEntrada').value == 3){
                      if(this.formAcordo.value['valorEntrada'] != null && this.formAcordo.value['valorEntrada'] != 0 &&
                        this.formAcordo.value['codigoFormaPagamentoEntrada'] != null && this.formAcordo.value['codigoFormaPagamentoEntrada'] != '' &&
                        this.formAcordo.value['dataVencimentoEntrada'] != null && this.formAcordo.value['dataVencimentoEntrada'] != ''
                        ){
                        if(this.formAcordo.value['codigoFormaPagamentoEntrada'] == 4 ){
                          if(this.formAcordo.value['banco'] != null && this.formAcordo.value['banco'] != '' &&
                            this.formAcordo.value['agencia'] != null && this.formAcordo.value['agencia'] != '' &&
                            this.formAcordo.value['conta'] != null && this.formAcordo.value['conta'] != ''
                            ){
                        this.mostrarBotaoProposta = true;
                        this.InformacoesGerais = false;
                        this.Terceiro = false;
                        this.DadosAcordo = false;
                        this.Valores = false;
                        this.Negociacao = false;
                        this.CondicoesPagamento = false;
                        this.ConfirmarGerar = true;
                        }else{
                        this.appComponent.createAlert('Preencha os campos referente a forma de pagamento À Vista.', 'error');
                        }
                      }else{
                        this.mostrarBotaoProposta = true;
                        this.InformacoesGerais = false;
                        this.Terceiro = false;
                        this.DadosAcordo = false;
                        this.Valores = false;
                        this.Negociacao = false;
                        this.CondicoesPagamento = false;
                        this.ConfirmarGerar = true;
                    }
                  }else{
                    this.appComponent.createAlert('Preencha os campos referente a forma de pagamento À Vista.', 'error');
                    }
                    }
        
                    if(this.formAcordo.get('radioEntrada').value == 2){
                      if(this.formAcordo.value['qtdParcelas'] != null && this.formAcordo.value['qtdParcelas'] != '' &&
                        this.formAcordo.value['codigoFormaPagamento'] != null && this.formAcordo.value['codigoFormaPagamento'] != '' &&
                        this.formAcordo.value['dataPrimeiroVencimento'] != null && this.formAcordo.value['dataPrimeiroVencimento'] != ''
                        ){
                          if(this.formAcordo.value['codigoFormaPagamentoEntrada'] == 4 ){
                            if(this.formAcordo.value['banco'] != null && this.formAcordo.value['banco'] != '' &&
                            this.formAcordo.value['agencia'] != null && this.formAcordo.value['agencia'] != '' &&
                            this.formAcordo.value['conta'] != null && this.formAcordo.value['conta'] != ''
                            ){
                        this.mostrarBotaoProposta = true;
                        this.InformacoesGerais = false;
                        this.Terceiro = false;
                        this.DadosAcordo = false;
                        this.Valores = false;
                        this.Negociacao = false;
                        this.CondicoesPagamento = false;
                        this.ConfirmarGerar = true;
                      }else{
                      this.appComponent.createAlert('Preencha os campos referente a forma de pagamento Sem entrada.', 'error');
                    }
                  }else{
                  this.mostrarBotaoProposta = true;
                  this.InformacoesGerais = false;
                  this.Terceiro = false;
                  this.DadosAcordo = false;
                  this.Valores = false;
                  this.Negociacao = false;
                  this.CondicoesPagamento = false;
                  this.ConfirmarGerar = true;
                  }
                }else{
                  this.appComponent.createAlert('Preencha os campos referente a forma de pagamento Sem entrada.', 'error');
                  }
                }
            
                if(this.formAcordo.get('radioEntrada').value == 1){
                  if(this.formAcordo.value['valorEntrada'] != null && this.formAcordo.value['valorEntrada'] != 0 &&
                      this.formAcordo.value['codigoFormaPagamentoEntrada'] != null && this.formAcordo.value['codigoFormaPagamentoEntrada'] != '' &&
                      this.formAcordo.value['dataVencimentoEntrada'] != null && this.formAcordo.value['dataVencimentoEntrada'] != '' &&
                      this.formAcordo.value['qtdParcelas'] != null && this.formAcordo.value['qtdParcelas'] != '' &&
                      this.formAcordo.value['codigoFormaPagamento'] != null && this.formAcordo.value['codigoFormaPagamento'] != '' &&
                      this.formAcordo.value['dataPrimeiroVencimento'] != null && this.formAcordo.value['dataPrimeiroVencimento'] != ''
                      ){ 
                        if(this.formAcordo.value['codigoFormaPagamentoEntrada'] == 4 ){
                        if(this.formAcordo.value['banco'] != null && this.formAcordo.value['banco'] != '' &&
                        this.formAcordo.value['agencia'] != null && this.formAcordo.value['agencia'] != '' &&
                        this.formAcordo.value['conta'] != null && this.formAcordo.value['conta'] != ''
                        ){
                        this.mostrarBotaoProposta = true;
                        this.InformacoesGerais = false;
                        this.Terceiro = false;
                        this.DadosAcordo = false;
                        this.Valores = false;
                        this.Negociacao = false;
                        this.CondicoesPagamento = false;
                        this.ConfirmarGerar = true;
                      }else{
                      this.appComponent.createAlert('Preencha os campos referente a forma de pagamento Com Entrada', 'error');
                    }
                  }else{
                  this.mostrarBotaoProposta = true;
                  this.InformacoesGerais = false;
                  this.Terceiro = false;
                  this.DadosAcordo = false;
                  this.Valores = false;
                  this.Negociacao = false;
                  this.CondicoesPagamento = false;
                  this.ConfirmarGerar = true;
                  }
                }else{
                this.appComponent.createAlert('Preencha os campos referente a forma de pagamento Com Entrada', 'error');
                      }
                    }
                  }
                  public Revisar(){
                      this.InformacoesGerais = true;
                      this.Terceiro = false;
                      this.DadosAcordo = false;
                      this.Valores = false;
                      this.Negociacao = false;
                      this.CondicoesPagamento = false;
                      this.ConfirmarGerar = false;
                        }
    }
